/*
  NFCARD · Editor de tarjetas
  ---------------------------------------------------------------
  Lo monta sections/nfcard-editor.liquid. Todo se pinta en un <canvas>
  con el mismo código que genera el archivo de impresión, así que lo que
  el cliente ve es exactamente lo que nos llega.

  Medidas reales: tarjeta CR80 de 85,6 x 53,98 mm, 2 mm de sangrado por
  cada lado y 3 mm de zona segura. El archivo final sale a 300 ppp.

  Necesita assets/nfcard-qr.js (qrcode-generator, licencia MIT) para
  dibujar los códigos QR.
*/
(function () {
  'use strict';

  var CR80 = { h: [85.6, 53.98], v: [53.98, 85.6] };
  /* medida obligatoria de un diseño ya hecho que sube el cliente:
     86 x 54 mm de tarjeta más 5 mm de margen (91 x 59 mm) */
  var DISENO = { h: [91, 59], v: [59, 91] };
  var SANGRADO = 2;
  var SEGURA = 3;
  var RADIO_ESQUINA = 3.18;
  var PT = 0.3528;
  var PPP = 300;
  var MAX_HISTORIA = 60;
  var CLAVE_GUARDADO = 'nfcard-editor-v1';

  /* ------------------------------------------------------------------
     Utilidades
  ------------------------------------------------------------------ */
  function $(sel, raiz) { return (raiz || document).querySelector(sel); }
  function $$(sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); }
  function el(tag, attrs, hijos) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') n.className = v;
      else if (k === 'text') n.textContent = v;
      else if (k === 'html') n.innerHTML = v;
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), v);
      else n.setAttribute(k, v === true ? '' : v);
    });
    (hijos || []).forEach(function (h) { if (h) n.appendChild(typeof h === 'string' ? document.createTextNode(h) : h); });
    return n;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function redondea(v, d) { var f = Math.pow(10, d || 1); return Math.round(v * f) / f; }
  function uid() { return 'e' + Math.random().toString(36).slice(2, 9); }
  function copia(o) { return JSON.parse(JSON.stringify(o)); }
  function hexValido(h) { return /^#[0-9a-fA-F]{6}$/.test(h || ''); }
  function luminancia(hex) {
    if (!hexValido(hex)) return 1;
    var c = [1, 3, 5].map(function (i) {
      var v = parseInt(hex.substr(i, 2), 16) / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  function tintaSobre(hex) { return luminancia(hex) > 0.36 ? '#0A0A0A' : '#FFFFFF'; }
  function contraste(a, b) {
    var la = luminancia(a), lb = luminancia(b);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
  }
  function euros(n) {
    return n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function mmTxt(v) { return String(redondea(v, 1)).replace('.', ','); }

  /* ------------------------------------------------------------------
     El editor
  ------------------------------------------------------------------ */
  function Editor(raiz, cfg) {
    this.raiz = raiz;
    this.cfg = cfg;
    this.imgs = {};
    this.qrCache = {};
    this.textoCache = {};
    this.historia = [];
    this.futuro = [];
    this.guiasSnap = [];
    this.arrastre = null;
    this.st = this.estadoInicial();
    this.montar();
  }

  Editor.prototype.estadoInicial = function () {
    var c = this.cfg;
    return {
      orient: 'h',
      cara: 'a',
      caras: { a: { fondo: '#FFFFFF', els: [] }, r: { fondo: '#FFFFFF', els: [] } },
      sel: null,
      guias: true,
      plantilla: null,
      empresa: '',
      c1: c.colorInicial || '#0B62D6',
      c2: '#0A0A0A',
      logo: null,
      chip: 'enlace',
      uso: 0,
      material: 'color',
      metal: 'oro',
      cantidad: 25,
      cantidadLibre: '',
      cantMetal: 25,
      empezado: false
    };
  };

  Editor.prototype.medidas = function (o) {
    var m = CR80[o || this.st.orient];
    return { W: m[0], H: m[1] };
  };
  Editor.prototype.cara = function (k) { return this.st.caras[k || this.st.cara]; };
  Editor.prototype.seleccionado = function () {
    var id = this.st.sel;
    if (!id) return null;
    var els = this.cara().els;
    for (var i = 0; i < els.length; i++) if (els[i].id === id) return els[i];
    return null;
  };

  /* ---------------- fuentes ---------------- */
  function familia(f) { return String(f.familia || '').replace(/["']/g, ''); }
  Editor.prototype.fuente = function (id) {
    var f = this.cfg.fuentes;
    for (var i = 0; i < f.length; i++) if (f[i].id === id) return f[i];
    return f[0];
  };
  Editor.prototype.cssFuente = function (e, px) {
    var f = this.fuente(e.font);
    var peso = e.peso >= 600 && f.negrita ? f.negrita : (f.normal || 400);
    return peso + ' ' + px.toFixed(2) + 'px "' + familia(f) + '", ' + (f.respaldo || 'sans-serif');
  };
  Editor.prototype.cargarFuentes = function () {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    var self = this, prom = [];
    this.cfg.fuentes.forEach(function (f) {
      prom.push(document.fonts.load((f.normal || 400) + ' 20px "' + familia(f) + '"'));
      if (f.negrita) prom.push(document.fonts.load(f.negrita + ' 20px "' + familia(f) + '"'));
    });
    return Promise.all(prom).catch(function () {}).then(function () { self.textoCache = {}; });
  };

  /* ---------------- maquetación de texto ----------------
     Se mide a una escala fija (10 px por mm) y se guarda en mm, así el
     resultado no depende del zoom: en pantalla y en el archivo de
     impresión las líneas se cortan en el mismo sitio. */
  Editor.prototype.maquetaTexto = function (e) {
    var clave = [e.txt, e.font, e.peso, e.tam, e.w, e.esp, e.mayus, e.alto || 1.2].join('|');
    var c = this.textoCache[clave];
    if (c) return c;
    var K = 10;
    var ctx = this.ctxMedida || (this.ctxMedida = document.createElement('canvas').getContext('2d'));
    var px = e.tam * PT * K;
    ctx.font = this.cssFuente(e, px);
    if ('letterSpacing' in ctx) ctx.letterSpacing = (e.esp || 0) * px + 'px';
    var txt = e.mayus ? (e.txt || '').toLocaleUpperCase('es-ES') : (e.txt || '');
    var anchoMax = e.w * K;
    var lineas = [];
    txt.split('\n').forEach(function (parrafo) {
      var palabras = parrafo.split(' ');
      var linea = '';
      palabras.forEach(function (p) {
        var prueba = linea ? linea + ' ' + p : p;
        if (linea && ctx.measureText(prueba).width > anchoMax) {
          lineas.push(linea);
          linea = p;
        } else {
          linea = prueba;
        }
      });
      lineas.push(linea);
    });
    var anchos = lineas.map(function (l) { return ctx.measureText(l).width / K; });
    var alto = (e.alto || 1.2) * e.tam * PT;
    c = { lineas: lineas, anchos: anchos, lh: alto, h: Math.max(alto, lineas.length * alto) };
    this.textoCache[clave] = c;
    return c;
  };
  Editor.prototype.altoDe = function (e) {
    if (e.t === 'text') e.h = this.maquetaTexto(e).h;
    return e.h;
  };

  /* ---------------- QR ---------------- */
  Editor.prototype.matrizQR = function (texto) {
    texto = texto || ' ';
    if (this.qrCache[texto]) return this.qrCache[texto];
    if (typeof window.qrcode !== 'function') return null;
    try {
      var q = window.qrcode(0, 'M');
      q.addData(unescape(encodeURIComponent(texto)));
      q.make();
      var n = q.getModuleCount(), m = [];
      for (var r = 0; r < n; r++) {
        var fila = [];
        for (var c = 0; c < n; c++) fila.push(q.isDark(r, c));
        m.push(fila);
      }
      this.qrCache[texto] = m;
      return m;
    } catch (err) {
      return null;
    }
  };

  /* ------------------------------------------------------------------
     Pintado. Una sola función para la pantalla y para el archivo.
     k = píxeles por milímetro; (ox, oy) = esquina de la línea de corte.
  ------------------------------------------------------------------ */
  Editor.prototype.pintaCara = function (ctx, claveCara, k, ox, oy, modo) {
    var cara = this.st.caras[claveCara];
    var m = this.medidas();
    var self = this;
    var S = SANGRADO;

    ctx.save();
    ctx.beginPath();
    if (modo === 'final') {
      redondo(ctx, ox, oy, m.W * k, m.H * k, RADIO_ESQUINA * k);
    } else {
      ctx.rect(ox - S * k, oy - S * k, (m.W + 2 * S) * k, (m.H + 2 * S) * k);
    }
    ctx.clip();
    ctx.fillStyle = this.esMetal() ? FONDO_METAL : (cara.fondo || '#FFFFFF');
    ctx.fillRect(ox - S * k, oy - S * k, (m.W + 2 * S) * k, (m.H + 2 * S) * k);

    cara.els.forEach(function (e) {
      if (e.oculto) return;
      self.altoDe(e);
      var cx = ox + (e.x + e.w / 2) * k, cy = oy + (e.y + e.h / 2) * k;
      ctx.save();
      ctx.translate(cx, cy);
      if (e.rot) ctx.rotate(e.rot * Math.PI / 180);
      if (e.opacidad !== undefined && e.opacidad < 1) ctx.globalAlpha = e.opacidad;
      self.pintaElemento(ctx, e, k, modo);
      ctx.restore();
    });
    ctx.restore();
  };

  function redondo(ctx, x, y, w, h, r) {
    r = Math.max(0, Math.min(r, w / 2, h / 2));
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  /* ---------------- stamping metálico ----------------
     En la tarjeta negra todo lo que se imprime sale en un solo metal.
     Los colores del diseño se guardan igual, así que al volver a la
     tarjeta blanca el cliente recupera su diseño a color. */
  var FONDO_METAL = '#0B0B0C';
  var METALES = {
    oro: { base: '#C9A85A', brillo: ['#8F6E2E', '#E8CF8E', '#B08D45', '#F2E0A6', '#9A7A3A'] },
    plata: { base: '#BFC3C8', brillo: ['#7E8186', '#F1F2F4', '#A7ABB1', '#E4E6E9', '#8D9095'] }
  };
  Editor.prototype.esMetal = function () { return this.st.material === 'metal'; };
  Editor.prototype.relleno = function (ctx, color, w, h) {
    if (!this.esMetal()) return color;
    var m = METALES[this.st.metal] || METALES.oro;
    var g = ctx.createLinearGradient(-w / 2, -h / 2, w / 2, h / 2);
    [0, 0.3, 0.5, 0.72, 1].forEach(function (p, i) { g.addColorStop(p, m.brillo[i]); });
    return g;
  };
  /* un logo o una imagen pasados a un solo metal: si tiene transparencia
     se usa su silueta; si no, las zonas oscuras */
  Editor.prototype.mascara = function (id) {
    var im = this.imgs[id];
    if (!im || !im.img.complete) return null;
    var metal = METALES[this.st.metal] || METALES.oro;
    var clave = id + '|' + this.st.metal;
    this.mascaras = this.mascaras || {};
    if (this.mascaras[clave]) return this.mascaras[clave];
    var max = 1400, f = Math.min(1, max / Math.max(im.w, im.h));
    var cv = document.createElement('canvas');
    cv.width = Math.max(1, Math.round(im.w * f)); cv.height = Math.max(1, Math.round(im.h * f));
    var c = cv.getContext('2d');
    c.drawImage(im.img, 0, 0, cv.width, cv.height);
    var d;
    try { d = c.getImageData(0, 0, cv.width, cv.height); } catch (err) { return null; }
    var px = d.data, transparente = false, i;
    for (i = 3; i < px.length; i += 16) if (px[i] < 245) { transparente = true; break; }
    var r = parseInt(metal.base.substr(1, 2), 16), g = parseInt(metal.base.substr(3, 2), 16), b = parseInt(metal.base.substr(5, 2), 16);
    for (i = 0; i < px.length; i += 4) {
      var a = transparente ? px[i + 3] : 255 - (0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2]);
      px[i] = r; px[i + 1] = g; px[i + 2] = b; px[i + 3] = a > 40 ? 255 : 0;
    }
    c.putImageData(d, 0, 0);
    c.globalCompositeOperation = 'source-atop';
    var gr = c.createLinearGradient(0, 0, cv.width, cv.height);
    [0, 0.3, 0.5, 0.72, 1].forEach(function (p, j) { gr.addColorStop(p, metal.brillo[j]); });
    c.fillStyle = gr; c.fillRect(0, 0, cv.width, cv.height);
    this.mascaras[clave] = cv;
    return cv;
  };

  Editor.prototype.pintaElemento = function (ctx, e, k, modo) {
    var w = e.w * k, h = e.h * k, x = -w / 2, y = -h / 2;
    var metal = this.esMetal();
    var self = this;
    var col = function (c) { return self.relleno(ctx, c, w, h); };
    if (metal && e.t === 'foto') {
      if (modo === 'pantalla') {
        ctx.setLineDash([3, 3]); ctx.strokeStyle = 'rgba(255,255,255,.35)'; ctx.strokeRect(x, y, w, h); ctx.setLineDash([]);
      }
      return;
    }
    if (e.t === 'rect') {
      ctx.beginPath();
      redondo(ctx, x, y, w, h, (e.radio || 0) * k);
      if (e.color && e.color !== 'none') { ctx.fillStyle = col(e.color); ctx.fill(); }
      if (e.borde) { ctx.lineWidth = e.borde * k; ctx.strokeStyle = col(e.colorBorde || '#0A0A0A'); ctx.stroke(); }
    } else if (e.t === 'elipse') {
      ctx.beginPath();
      ctx.ellipse(0, 0, w / 2, h / 2, 0, 0, Math.PI * 2);
      if (e.color && e.color !== 'none') { ctx.fillStyle = col(e.color); ctx.fill(); }
      if (e.borde) { ctx.lineWidth = e.borde * k; ctx.strokeStyle = col(e.colorBorde || '#0A0A0A'); ctx.stroke(); }
    } else if (e.t === 'img') {
      var im = this.imgs[e.src];
      var mk = metal ? this.mascara(e.src) : null;
      if (mk) {
        ctx.drawImage(mk, x, y, w, h);
      } else if (im && im.img.complete) {
        ctx.drawImage(im.img, x, y, w, h);
      } else if (modo !== 'final' && modo !== 'export') {
        ctx.fillStyle = '#E9ECF0'; ctx.fillRect(x, y, w, h);
        ctx.fillStyle = '#5F6368'; ctx.font = '600 ' + Math.max(9, 2.4 * k) + 'px sans-serif';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText('Vuelve a subir la imagen', 0, 0);
      }
    } else if (e.t === 'qr') {
      var mtz = this.matrizQR(e.url);
      var fondoQR = metal ? null : e.fondoQR;
      if (fondoQR) { ctx.fillStyle = fondoQR; ctx.fillRect(x, y, w, h); }
      if (mtz) {
        var n = mtz.length, margen = fondoQR ? 2 : 0, total = n + margen * 2;
        var paso = w / total;
        ctx.fillStyle = col(e.color || '#0A0A0A');
        for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) {
          if (mtz[r][c]) ctx.fillRect(x + (c + margen) * paso, y + (r + margen) * paso, paso + 0.35, paso + 0.35);
        }
      }
    } else if (e.t === 'nfc') {
      pintaNFC(ctx, w, col(e.color || '#0A0A0A'));
    } else if (e.t === 'foto') {
      ctx.save();
      ctx.beginPath();
      redondo(ctx, x, y, w, h, (e.radio || 0) * k);
      ctx.clip();
      ctx.fillStyle = e.color || '#DDE1E6';
      ctx.fillRect(x, y, w, h);
      ctx.fillStyle = e.colorSilueta || '#B4BBC4';
      var cabeza = Math.min(w, h) * 0.2;
      ctx.beginPath(); ctx.arc(0, y + h * 0.4, cabeza, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(0, y + h * 0.98, w * 0.4, h * 0.32, 0, Math.PI, 0); ctx.fill();
      ctx.restore();
    } else if (e.t === 'text') {
      var lay = this.maquetaTexto(e);
      var px = e.tam * PT * k;
      ctx.font = this.cssFuente(e, px);
      if ('letterSpacing' in ctx) ctx.letterSpacing = (e.esp || 0) * px + 'px';
      ctx.fillStyle = col(e.color || '#0A0A0A');
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'left';
      lay.lineas.forEach(function (l, i) {
        var lw = lay.anchos[i] * k, lx = x;
        if (e.alin === 'center') lx = -lw / 2;
        else if (e.alin === 'right') lx = x + w - lw;
        ctx.fillText(l, lx, y + (i + 0.5) * lay.lh * k);
      });
      if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
    }
  };

  function pintaNFC(ctx, w, color) {
    /* el símbolo de pago sin contacto: un punto y tres ondas */
    ctx.save();
    ctx.strokeStyle = color; ctx.fillStyle = color;
    ctx.lineCap = 'round';
    var lw = w * 0.085;
    ctx.lineWidth = lw;
    var cx = -w * 0.32;
    ctx.beginPath(); ctx.arc(cx, 0, lw * 0.75, 0, Math.PI * 2); ctx.fill();
    [0.24, 0.47, 0.7].forEach(function (r) {
      ctx.beginPath();
      ctx.arc(cx, 0, r * w, -Math.PI / 4.2, Math.PI / 4.2);
      ctx.stroke();
    });
    ctx.restore();
  }

  /* ------------------------------------------------------------------
     Montaje del DOM
  ------------------------------------------------------------------ */
  Editor.prototype.montar = function () {
    var self = this, R = this.raiz;
    this.lienzo = $('[data-lienzo]', R);
    this.canvas = $('canvas', this.lienzo);
    this.ctx = this.canvas.getContext('2d');
    this.panel = $('[data-panel]', R);
    this.inicio = $('[data-inicio]', R);
    this.fileLogo = $('[data-file="logo"]', R);
    this.fileDiseno = $('[data-file="diseno"]', R);
    this.fileImagen = $('[data-file="imagen"]', R);
    this.fileFondo = $('[data-file="fondo"]', R);
    this.aviso = $('[data-aviso]', R);

    this.leerGuardado();
    this.leerUrl();

    /* barra superior */
    $$('[data-cara]', R).forEach(function (b) {
      b.addEventListener('click', function () { self.cambiaCara(b.getAttribute('data-cara')); });
    });
    $$('[data-orient]', R).forEach(function (b) {
      b.addEventListener('click', function () { self.cambiaOrient(b.getAttribute('data-orient')); });
    });
    $('[data-accion="deshacer"]', R).addEventListener('click', function () { self.deshacer(); });
    $('[data-accion="rehacer"]', R).addEventListener('click', function () { self.rehacer(); });
    $('[data-accion="guias"]', R).addEventListener('click', function () {
      self.st.guias = !self.st.guias; self.render(); self.pintaBarra();
    });

    /* pestañas */
    $$('[data-tab]', R).forEach(function (t) {
      t.addEventListener('click', function () { self.pestana(t.getAttribute('data-tab')); });
    });

    /* pantalla de inicio */
    $$('[data-empezar]', R).forEach(function (b) {
      b.addEventListener('click', function () { self.empezar(b.getAttribute('data-empezar')); });
    });

    /* archivos */
    this.fileLogo.addEventListener('change', function () { self.subeArchivo(this, 'logo'); });
    this.fileDiseno.addEventListener('change', function () { self.subeArchivo(this, 'diseno'); });
    this.fileImagen.addEventListener('change', function () { self.subeArchivo(this, 'imagen'); });
    this.fileFondo.addEventListener('change', function () { self.subeArchivo(this, 'fondo'); });

    /* soltar archivos sobre el lienzo */
    this.lienzo.addEventListener('dragover', function (e) { e.preventDefault(); self.lienzo.classList.add('is-soltar'); });
    this.lienzo.addEventListener('dragleave', function () { self.lienzo.classList.remove('is-soltar'); });
    this.lienzo.addEventListener('drop', function (e) {
      e.preventDefault(); self.lienzo.classList.remove('is-soltar');
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) self.leeImagen(f, self.st.empezado ? 'imagen' : 'diseno');
    });

    /* lienzo */
    this.canvas.addEventListener('pointerdown', function (e) { self.pDown(e); });
    window.addEventListener('pointermove', function (e) { self.pMove(e); });
    window.addEventListener('pointerup', function (e) { self.pUp(e); });
    this.canvas.addEventListener('pointermove', function (e) { if (!self.arrastre) self.cursor(e); });
    this.canvas.addEventListener('dblclick', function () {
      var s = self.seleccionado();
      if (s && s.t === 'text') { self.pestana('elemento'); var ta = $('textarea', self.panel); if (ta) { ta.focus(); ta.select(); } }
    });

    /* teclado */
    R.addEventListener('keydown', function (e) { self.teclado(e); });

    /* tamaño */
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () { self.dimensiona(); }).observe(this.lienzo);
    }
    window.addEventListener('resize', function () { self.dimensiona(); });

    this.construyePaneles();
    this.dimensiona();
    this.cargarFuentes().then(function () { self.render(); self.pintaPaneles(); });
    if (document.fonts && document.fonts.addEventListener) {
      document.fonts.addEventListener('loadingdone', function () { self.textoCache = {}; self.render(); });
    }
    this.pintaBarra();
    this.pintaPaneles();
    this.render();
    this.pestana(this.st.empezado ? 'diseno' : 'diseno');
  };

  Editor.prototype.dimensiona = function () {
    var r = this.lienzo.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    this.cssW = Math.max(200, r.width);
    this.cssH = Math.max(200, r.height);
    this.canvas.width = Math.round(this.cssW * dpr);
    this.canvas.height = Math.round(this.cssH * dpr);
    this.canvas.style.width = this.cssW + 'px';
    this.canvas.style.height = this.cssH + 'px';
    this.dpr = dpr;
    this.render();
  };

  /* geometría de la vista: dónde cae la tarjeta dentro del lienzo */
  Editor.prototype.vista = function () {
    var m = this.medidas();
    var margen = this.cssW < 520 ? 22 : 54;
    var ancho = m.W + 2 * SANGRADO, alto = m.H + 2 * SANGRADO;
    var k = Math.min((this.cssW - margen * 2) / ancho, (this.cssH - margen * 2) / alto);
    var ox = (this.cssW - m.W * k) / 2, oy = (this.cssH - m.H * k) / 2;
    return { k: k, ox: ox, oy: oy, W: m.W, H: m.H };
  };

  /* ------------------------------------------------------------------
     Render de pantalla
  ------------------------------------------------------------------ */
  Editor.prototype.render = function () {
    if (!this.ctx || !this.cssW) return;
    var ctx = this.ctx, v = this.vista(), k = v.k, S = SANGRADO;
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    ctx.clearRect(0, 0, this.cssW, this.cssH);

    var final = !this.st.guias;

    /* sombra de la tarjeta */
    ctx.save();
    ctx.shadowColor = 'rgba(16,24,40,.16)';
    ctx.shadowBlur = 28; ctx.shadowOffsetY = 10;
    ctx.beginPath();
    redondo(ctx, v.ox, v.oy, v.W * k, v.H * k, RADIO_ESQUINA * k);
    ctx.fillStyle = '#FFFFFF'; ctx.fill();
    ctx.restore();

    this.pintaCara(ctx, this.st.cara, k, v.ox, v.oy, final ? 'final' : 'pantalla');

    if (!final) {
      /* zona de sangrado: lo que se corta se ve velado */
      ctx.save();
      ctx.beginPath();
      ctx.rect(v.ox - S * k, v.oy - S * k, (v.W + 2 * S) * k, (v.H + 2 * S) * k);
      redondo(ctx, v.ox, v.oy, v.W * k, v.H * k, RADIO_ESQUINA * k);
      ctx.fillStyle = 'rgba(255,255,255,.55)';
      ctx.fill('evenodd');
      /* línea de corte */
      ctx.beginPath();
      redondo(ctx, v.ox, v.oy, v.W * k, v.H * k, RADIO_ESQUINA * k);
      ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(10,10,10,.55)'; ctx.stroke();
      /* sangrado */
      ctx.setLineDash([2, 3]);
      ctx.strokeStyle = 'rgba(214,48,11,.6)';
      ctx.strokeRect(v.ox - S * k + 0.5, v.oy - S * k + 0.5, (v.W + 2 * S) * k - 1, (v.H + 2 * S) * k - 1);
      /* zona segura */
      ctx.strokeStyle = 'rgba(11,98,214,.7)';
      ctx.setLineDash([5, 4]);
      ctx.strokeRect(v.ox + SEGURA * k, v.oy + SEGURA * k, (v.W - 2 * SEGURA) * k, (v.H - 2 * SEGURA) * k);
      ctx.restore();
    }

    /* guías de alineación mientras se arrastra */
    if (this.arrastre && this.guiasSnap.length) {
      ctx.save();
      ctx.strokeStyle = '#E5157A'; ctx.lineWidth = 1;
      this.guiasSnap.forEach(function (g) {
        ctx.beginPath();
        if (g.eje === 'x') { ctx.moveTo(v.ox + g.v * k, v.oy - 12); ctx.lineTo(v.ox + g.v * k, v.oy + v.H * k + 12); }
        else { ctx.moveTo(v.ox - 12, v.oy + g.v * k); ctx.lineTo(v.ox + v.W * k + 12, v.oy + g.v * k); }
        ctx.stroke();
      });
      ctx.restore();
    }

    /* selección */
    var s = this.seleccionado();
    if (s) this.pintaSeleccion(ctx, s, v);

    /* elementos variables: se marcan solo en pantalla */
    if (!final) this.marcaVariables(ctx, v);

    this.programaMiniaturas();
    this.programaGuardado();
  };

  Editor.prototype.pintaSeleccion = function (ctx, e, v) {
    var k = v.k, w = e.w * k, h = e.h * k;
    var cx = v.ox + (e.x + e.w / 2) * k, cy = v.oy + (e.y + e.h / 2) * k;
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate((e.rot || 0) * Math.PI / 180);
    ctx.strokeStyle = '#0B62D6'; ctx.lineWidth = 1.5;
    ctx.strokeRect(-w / 2, -h / 2, w, h);
    /* asa de giro */
    ctx.beginPath(); ctx.moveTo(0, -h / 2); ctx.lineTo(0, -h / 2 - 22); ctx.stroke();
    ctx.beginPath(); ctx.arc(0, -h / 2 - 26, 6, 0, Math.PI * 2);
    ctx.fillStyle = '#FFFFFF'; ctx.fill(); ctx.stroke();
    /* asas de tamaño */
    [[-1, -1], [1, -1], [1, 1], [-1, 1]].forEach(function (p) {
      ctx.beginPath();
      ctx.rect(p[0] * w / 2 - 5, p[1] * h / 2 - 5, 10, 10);
      ctx.fillStyle = '#FFFFFF'; ctx.fill(); ctx.stroke();
    });
    ctx.restore();
  };

  Editor.prototype.marcaVariables = function (ctx, v) {
    var k = v.k, sel = this.st.sel;
    this.cara().els.forEach(function (e) {
      if (!e.variable && e.t !== 'foto') return;
      var w = e.w * k, h = e.h * k;
      var cx = v.ox + (e.x + e.w / 2) * k, cy = v.oy + (e.y + e.h / 2) * k;
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate((e.rot || 0) * Math.PI / 180);
      ctx.setLineDash([3, 3]);
      ctx.strokeStyle = 'rgba(229,21,122,.75)'; ctx.lineWidth = 1;
      ctx.strokeRect(-w / 2 - 2, -h / 2 - 2, w + 4, h + 4);
      ctx.setLineDash([]);
      if (e.id !== sel) { ctx.restore(); return; }
      ctx.font = '600 10px system-ui, sans-serif';
      var etq = e.t === 'foto' ? 'Foto de cada persona' : 'Cambia en cada tarjeta';
      var tw = ctx.measureText(etq).width + 10;
      ctx.fillStyle = '#E5157A';
      ctx.fillRect(w / 2 + 2 - tw, -h / 2 - 18, tw, 14);
      ctx.fillStyle = '#FFFFFF'; ctx.textBaseline = 'middle';
      ctx.fillText(etq, w / 2 + 7 - tw, -h / 2 - 11);
      ctx.restore();
    });
  };

  Editor.prototype.programaMiniaturas = function () {
    var self = this;
    if (this._mini) return;
    this._mini = requestAnimationFrame(function () {
      self._mini = null;
      $$('[data-mini]', self.raiz).forEach(function (cv) {
        var clave = cv.getAttribute('data-mini');
        var m = self.medidas();
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var cw = cv.clientWidth || 96, ch = cv.clientHeight || 64;
        cv.width = cw * dpr; cv.height = ch * dpr;
        var c = cv.getContext('2d');
        c.setTransform(dpr, 0, 0, dpr, 0, 0);
        c.clearRect(0, 0, cw, ch);
        var k = Math.min((cw - 8) / m.W, (ch - 8) / m.H);
        var ox = (cw - m.W * k) / 2, oy = (ch - m.H * k) / 2;
        self.pintaCara(c, clave, k, ox, oy, 'final');
        c.beginPath(); redondo(c, ox, oy, m.W * k, m.H * k, RADIO_ESQUINA * k);
        c.strokeStyle = 'rgba(10,10,10,.14)'; c.lineWidth = 1; c.stroke();
      });
    });
  };

  /* ------------------------------------------------------------------
     Interacción con el puntero
  ------------------------------------------------------------------ */
  Editor.prototype.puntoMM = function (ev) {
    var r = this.canvas.getBoundingClientRect(), v = this.vista();
    var px = ev.clientX - r.left, py = ev.clientY - r.top;
    return { x: (px - v.ox) / v.k, y: (py - v.oy) / v.k, px: px, py: py, v: v };
  };

  function aLocal(e, x, y) {
    var cx = e.x + e.w / 2, cy = e.y + e.h / 2;
    var a = -(e.rot || 0) * Math.PI / 180;
    var dx = x - cx, dy = y - cy;
    return { x: dx * Math.cos(a) - dy * Math.sin(a), y: dx * Math.sin(a) + dy * Math.cos(a) };
  }
  function aGlobal(e, lx, ly, cx, cy) {
    var a = (e.rot || 0) * Math.PI / 180;
    return { x: cx + lx * Math.cos(a) - ly * Math.sin(a), y: cy + lx * Math.sin(a) + ly * Math.cos(a) };
  }

  Editor.prototype.asaEn = function (p) {
    var e = this.seleccionado();
    if (!e) return null;
    var k = p.v.k;
    var l = aLocal(e, p.x, p.y);
    var lx = l.x * k, ly = l.y * k, w = e.w * k, h = e.h * k;
    var tol = (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ? 16 : 9;
    if (Math.abs(lx) < tol + 2 && Math.abs(ly - (-h / 2 - 26)) < tol + 2) return { tipo: 'girar' };
    var esquinas = [[-1, -1], [1, -1], [1, 1], [-1, 1]];
    for (var i = 0; i < 4; i++) {
      var c = esquinas[i];
      if (Math.abs(lx - c[0] * w / 2) < tol && Math.abs(ly - c[1] * h / 2) < tol) return { tipo: 'escalar', sx: c[0], sy: c[1] };
    }
    return null;
  };

  Editor.prototype.elementoEn = function (p) {
    var els = this.cara().els;
    var tol = 1 / p.v.k * 4;
    for (var i = els.length - 1; i >= 0; i--) {
      var e = els[i];
      if (e.bloqueado || e.oculto) continue;
      this.altoDe(e);
      var l = aLocal(e, p.x, p.y);
      if (Math.abs(l.x) <= e.w / 2 + tol && Math.abs(l.y) <= e.h / 2 + tol) return e;
    }
    return null;
  };

  Editor.prototype.cursor = function (ev) {
    var p = this.puntoMM(ev);
    var asa = this.asaEn(p);
    var c = 'default';
    if (asa) c = asa.tipo === 'girar' ? 'grab' : ((asa.sx * asa.sy > 0) ? 'nwse-resize' : 'nesw-resize');
    else if (this.elementoEn(p)) c = 'move';
    this.canvas.style.cursor = c;
  };

  Editor.prototype.pDown = function (ev) {
    if (ev.button !== undefined && ev.button !== 0) return;
    var p = this.puntoMM(ev);
    var asa = this.asaEn(p);
    var e = asa ? this.seleccionado() : this.elementoEn(p);
    if (!e) {
      this.selecciona(null);
      return;
    }
    ev.preventDefault();
    this.raiz.focus({ preventScroll: true });
    if (!asa) this.selecciona(e.id);
    this.altoDe(e);
    this.arrastre = {
      tipo: asa ? asa.tipo : 'mover', sx: asa && asa.sx, sy: asa && asa.sy,
      inicio: p, orig: copia(e), id: e.id, cambiado: false, puntero: ev.pointerId
    };
    try { this.canvas.setPointerCapture(ev.pointerId); } catch (err) {}
  };

  Editor.prototype.pMove = function (ev) {
    var a = this.arrastre;
    if (!a) return;
    var e = this.seleccionado();
    if (!e || e.id !== a.id) { this.arrastre = null; return; }
    var p = this.puntoMM(ev), o = a.orig;
    a.cambiado = true;
    if (a.tipo === 'mover') {
      var nx = o.x + (p.x - a.inicio.x), ny = o.y + (p.y - a.inicio.y);
      var snap = ev.altKey ? { x: nx, y: ny, g: [] } : this.ajusta(e, nx, ny, p.v.k);
      e.x = snap.x; e.y = snap.y;
      this.guiasSnap = snap.g;
    } else if (a.tipo === 'escalar') {
      var cx = o.x + o.w / 2, cy = o.y + o.h / 2;
      var l = aLocal(o, p.x, p.y);
      var A = { x: -a.sx * o.w / 2, y: -a.sy * o.h / 2 };
      var D = { x: a.sx * o.w / 2, y: a.sy * o.h / 2 };
      var libre = (e.t === 'rect' || e.t === 'elipse' || e.t === 'foto') && !ev.shiftKey;
      var nw, nh;
      if (libre) {
        nw = Math.max(1, Math.abs(l.x - A.x)); nh = Math.max(1, Math.abs(l.y - A.y));
      } else {
        var dx = D.x - A.x, dy = D.y - A.y;
        var f = ((l.x - A.x) * dx + (l.y - A.y) * dy) / (dx * dx + dy * dy);
        f = Math.max(f, 0.05);
        nw = Math.max(1, o.w * f); nh = Math.max(0.5, o.h * f);
        if (e.t === 'text') { e.tam = clamp(redondea(o.tam * f, 1), 3, 160); }
      }
      var ncL = { x: A.x + a.sx * nw / 2, y: A.y + a.sy * nh / 2 };
      var ncG = aGlobal(o, ncL.x, ncL.y, cx, cy);
      e.w = nw;
      if (e.t !== 'text') e.h = nh;
      this.altoDe(e);
      e.x = ncG.x - e.w / 2; e.y = ncG.y - e.h / 2;
    } else if (a.tipo === 'girar') {
      var ccx = o.x + o.w / 2, ccy = o.y + o.h / 2;
      var ang = Math.atan2(p.y - ccy, p.x - ccx) * 180 / Math.PI + 90;
      if (!ev.shiftKey) {
        var cerca = Math.round(ang / 45) * 45;
        if (Math.abs(ang - cerca) < 4) ang = cerca;
      }
      ang = ((ang + 540) % 360) - 180;
      e.rot = Math.round(ang);
    }
    this.render();
    this.refrescaCampos();
  };

  Editor.prototype.pUp = function () {
    var a = this.arrastre;
    if (!a) return;
    this.arrastre = null;
    this.guiasSnap = [];
    if (a.cambiado) this.guardaHistoria(a.antes);
    this.render();
    this.pintaPaneles();
  };

  /* imán: centro de la tarjeta, bordes de la zona segura y bordes de los demás */
  Editor.prototype.ajusta = function (e, nx, ny, k) {
    var m = this.medidas(), tol = 6 / k, g = [];
    if (e.rot) return { x: nx, y: ny, g: g };
    var objX = [m.W / 2, SEGURA, m.W - SEGURA, -SANGRADO, m.W + SANGRADO];
    var objY = [m.H / 2, SEGURA, m.H - SEGURA, -SANGRADO, m.H + SANGRADO];
    this.cara().els.forEach(function (o) {
      if (o.id === e.id || o.rot) return;
      objX.push(o.x, o.x + o.w / 2, o.x + o.w);
      objY.push(o.y, o.y + o.h / 2, o.y + o.h);
    });
    function mejor(pos, tam, objs) {
      var puntos = [pos, pos + tam / 2, pos + tam], best = null;
      puntos.forEach(function (pt, i) {
        objs.forEach(function (ob) {
          var d = Math.abs(pt - ob);
          if (d < tol && (!best || d < best.d)) best = { d: d, nuevo: pos + (ob - pt), v: ob };
        });
      });
      return best;
    }
    var bx = mejor(nx, e.w, objX), by = mejor(ny, e.h, objY);
    if (bx) { nx = bx.nuevo; g.push({ eje: 'x', v: bx.v }); }
    if (by) { ny = by.nuevo; g.push({ eje: 'y', v: by.v }); }
    return { x: nx, y: ny, g: g };
  };

  Editor.prototype.teclado = function (ev) {
    var t = ev.target;
    var escribiendo = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable);
    var mod = ev.ctrlKey || ev.metaKey;
    if (mod && (ev.key === 'z' || ev.key === 'Z') && !escribiendo) {
      ev.preventDefault();
      if (ev.shiftKey) this.rehacer(); else this.deshacer();
      return;
    }
    if (mod && (ev.key === 'y' || ev.key === 'Y') && !escribiendo) { ev.preventDefault(); this.rehacer(); return; }
    if (escribiendo) return;
    var s = this.seleccionado();
    if (!s) return;
    if (ev.key === 'Delete' || ev.key === 'Backspace') { ev.preventDefault(); this.borra(); return; }
    if (mod && (ev.key === 'd' || ev.key === 'D')) { ev.preventDefault(); this.duplica(); return; }
    var paso = ev.shiftKey ? 2 : 0.5, mov = null;
    if (ev.key === 'ArrowLeft') mov = [-paso, 0];
    if (ev.key === 'ArrowRight') mov = [paso, 0];
    if (ev.key === 'ArrowUp') mov = [0, -paso];
    if (ev.key === 'ArrowDown') mov = [0, paso];
    if (ev.key === 'Escape') { this.selecciona(null); return; }
    if (mov) {
      ev.preventDefault();
      var antes = this.instantanea();
      s.x += mov[0]; s.y += mov[1];
      this.guardaHistoria(antes);
      this.render(); this.refrescaCampos();
    }
  };

  /* ------------------------------------------------------------------
     Historia (deshacer / rehacer)
  ------------------------------------------------------------------ */
  Editor.prototype.instantanea = function () {
    return JSON.stringify({ o: this.st.orient, c: this.st.caras, p: this.st.plantilla, c1: this.st.c1, c2: this.st.c2 });
  };
  Editor.prototype.guardaHistoria = function (antes) {
    var ahora = this.instantanea();
    antes = antes || this._ultima || ahora;
    if (antes === ahora) { this._ultima = ahora; return; }
    this.historia.push(antes);
    if (this.historia.length > MAX_HISTORIA) this.historia.shift();
    this.futuro = [];
    this._ultima = ahora;
    this.pintaBarra();
  };
  Editor.prototype.restaura = function (snap) {
    var d = JSON.parse(snap);
    this.st.orient = d.o; this.st.caras = d.c; this.st.plantilla = d.p;
    this.st.c1 = d.c1; this.st.c2 = d.c2;
    this._ultima = snap;
    if (!this.seleccionado()) this.st.sel = null;
    this.textoCache = {};
    this.render(); this.pintaBarra(); this.pintaPaneles();
  };
  Editor.prototype.deshacer = function () {
    if (!this.historia.length) return;
    this.futuro.push(this.instantanea());
    this.restaura(this.historia.pop());
  };
  Editor.prototype.rehacer = function () {
    if (!this.futuro.length) return;
    this.historia.push(this.instantanea());
    this.restaura(this.futuro.pop());
  };
  /* envoltorio: cualquier cambio desde el panel pasa por aquí */
  Editor.prototype.cambia = function (fn, sinHistoria) {
    var antes = this.instantanea();
    fn.call(this);
    if (!sinHistoria) this.guardaHistoria(antes);
    this.st.empezado = true;
    this.ocultaInicio();
    this.render();
  };

  /* ------------------------------------------------------------------
     Operaciones
  ------------------------------------------------------------------ */
  Editor.prototype.selecciona = function (id) {
    this.st.sel = id;
    this.render();
    if (id) this.pestana('elemento');
    else if (this.tabActiva === 'elemento') this.pestana('anadir');
    this.pintaPaneles();
  };
  Editor.prototype.cambiaCara = function (c) {
    if (c !== 'a' && c !== 'r') return;
    this.st.cara = c; this.st.sel = null;
    this.render(); this.pintaBarra(); this.pintaPaneles();
    if (this.tabActiva === 'elemento') this.pestana('anadir');
  };
  Editor.prototype.anade = function (e, sinSeleccion) {
    e.id = e.id || uid();
    var self = this;
    this.cambia(function () {
      self.cara().els.push(e);
      if (!sinSeleccion) self.st.sel = e.id;
    });
    if (!sinSeleccion) this.pestana('elemento');
    this.pintaPaneles();
    return e;
  };
  Editor.prototype.borra = function () {
    var s = this.seleccionado();
    if (!s) return;
    var self = this;
    this.cambia(function () {
      self.cara().els = self.cara().els.filter(function (e) { return e.id !== s.id; });
      self.st.sel = null;
    });
    this.pestana('anadir');
    this.pintaPaneles();
  };
  Editor.prototype.duplica = function () {
    var s = this.seleccionado();
    if (!s) return;
    var d = copia(s); d.id = uid(); d.x += 3; d.y += 3;
    this.anade(d);
  };
  Editor.prototype.capa = function (dir) {
    var s = this.seleccionado();
    if (!s) return;
    var self = this;
    this.cambia(function () {
      var els = self.cara().els, i = els.indexOf(s);
      els.splice(i, 1);
      if (dir === 'arriba') els.splice(Math.min(els.length, i + 1), 0, s);
      else if (dir === 'abajo') els.splice(Math.max(0, i - 1), 0, s);
      else if (dir === 'frente') els.push(s);
      else els.unshift(s);
    });
  };
  Editor.prototype.centra = function (eje) {
    var s = this.seleccionado();
    if (!s) return;
    var m = this.medidas(), self = this;
    this.altoDe(s);
    this.cambia(function () {
      if (eje !== 'y') s.x = (m.W - s.w) / 2;
      if (eje !== 'x') s.y = (m.H - s.h) / 2;
    });
    this.refrescaCampos();
    self.render();
  };

  Editor.prototype.cambiaOrient = function (o) {
    if (o === this.st.orient || !CR80[o]) return;
    var self = this;
    var antes = this.instantanea();
    var viejo = this.medidas(), nuevo = this.medidas(o);
    if (this.st.plantilla && this.plantillaPar(this.st.plantilla)) {
      var par = this.plantillaPar(this.st.plantilla);
      this.st.orient = o;
      this.aplicaPlantilla(par, true);
    } else {
      this.st.orient = o;
      ['a', 'r'].forEach(function (c) {
        self.st.caras[c].els.forEach(function (e) {
          self.altoDe(e);
          if (e.cubre) { self.cubre(e, 'cubrir', nuevo); return; }
          var cx = (e.x + e.w / 2) / viejo.W * nuevo.W, cy = (e.y + e.h / 2) / viejo.H * nuevo.H;
          var f = Math.min(1, (nuevo.W - 2 * SEGURA) / e.w, e.t === 'text' ? 1 : (nuevo.H - 2 * SEGURA) / e.h);
          if (f < 1) {
            e.w *= f;
            if (e.t === 'text') e.tam = redondea(e.tam * f, 1); else e.h *= f;
          }
          self.altoDe(e);
          e.x = cx - e.w / 2; e.y = cy - e.h / 2;
        });
      });
      if (this.st.empezado) this.avisa('Hemos recolocado el diseño en ' + (o === 'v' ? 'vertical' : 'horizontal') + '. Revísalo antes de seguir.');
    }
    this.textoCache = {};
    this.guardaHistoria(antes);
    this.dimensiona();
    this.pintaBarra(); this.pintaPaneles();
  };

  /* ajusta una imagen a la tarjeta: 'cubrir' llena hasta el sangrado, 'ajustar' cabe entera */
  Editor.prototype.cubre = function (e, modo, m) {
    m = m || this.medidas();
    var im = this.imgs[e.src];
    var asp = im ? im.w / im.h : e.w / e.h;
    var W = m.W + 2 * SANGRADO, H = m.H + 2 * SANGRADO;
    if (modo === 'ajustar') { W = m.W - 2 * SEGURA; H = m.H - 2 * SEGURA; }
    var w, h;
    if ((modo === 'cubrir') === (W / H > asp)) { w = W; h = W / asp; } else { h = H; w = H * asp; }
    e.w = w; e.h = h; e.rot = 0;
    e.x = (m.W - w) / 2; e.y = (m.H - h) / 2;
    e.cubre = modo === 'cubrir';
  };

  /* ------------------------------------------------------------------
     Imágenes
  ------------------------------------------------------------------ */
  Editor.prototype.subeArchivo = function (input, destino) {
    var f = input.files && input.files[0];
    input.value = '';
    if (f) this.leeImagen(f, destino);
  };
  Editor.prototype.leeImagen = function (f, destino) {
    var self = this;
    if (!/^image\/(png|jpe?g|webp|svg\+xml|gif)$/i.test(f.type)) {
      this.avisa('Ese formato no se puede ver aquí. Sube PNG, JPG, SVG o WEBP. Si lo tienes en PDF o AI, mándanoslo con el pedido.');
      return;
    }
    if (f.size > 25 * 1024 * 1024) { this.avisa('La imagen pesa más de 25 MB. Prueba con una versión más ligera.'); return; }
    var lector = new FileReader();
    lector.onload = function () {
      var img = new Image();
      img.onload = function () {
        var id = 'i' + Math.random().toString(36).slice(2, 8);
        var w = img.naturalWidth || 1000, h = img.naturalHeight || 1000;
        if (f.type === 'image/svg+xml' && (!img.naturalWidth || img.naturalWidth < 600)) { w = 1200; h = img.naturalHeight && img.naturalWidth ? 1200 * img.naturalHeight / img.naturalWidth : 1200; }
        if (destino === 'diseno') {
          /* un diseño ya hecho tiene que medir 91 x 59 mm (horizontal) o 59 x 91 mm (vertical) */
          var r = w / h, rh = DISENO.h[0] / DISENO.h[1], rv = DISENO.v[0] / DISENO.v[1];
          var o = Math.abs(r - rh) / rh <= 0.03 ? 'h' : (Math.abs(r - rv) / rv <= 0.03 ? 'v' : null);
          if (!o) {
            self.avisa('Tu diseño tiene que medir 91 × 59 mm en horizontal o 59 × 91 mm en vertical (la tarjeta de 86 × 54 mm más 5 mm de margen). El que has subido (' + Math.round(w) + ' × ' + Math.round(h) + ' px) no tiene esa proporción. A 300 ppp son 1075 × 697 px o 697 × 1075 px.');
            return;
          }
          if (o !== self.st.orient) self.cambiaOrient(o);
          self.avisoRes = Math.max(w, h) < 1075 && f.type !== 'image/svg+xml'
            ? ' Ojo: tu imagen mide ' + Math.round(w) + ' × ' + Math.round(h) + ' px; para que salga nítida necesita ' + (o === 'h' ? '1075 × 697' : '697 × 1075') + ' px (300 ppp).'
            : '';
        }
        self.imgs[id] = { img: img, src: lector.result, nombre: f.name, w: w, h: h, tipo: f.type, archivo: f };
        self.colocaImagen(id, destino);
      };
      img.onerror = function () { self.avisa('No hemos podido abrir esa imagen.'); };
      img.src = lector.result;
    };
    lector.readAsDataURL(f);
  };
  Editor.prototype.colocaImagen = function (id, destino) {
    var m = this.medidas(), im = this.imgs[id], self = this;
    var e = { t: 'img', src: id, x: 0, y: 0, w: 20, h: 20, rot: 0 };
    if (destino === 'diseno' || destino === 'fondo') {
      this.cubre(e, 'cubrir');
      if (destino === 'diseno') {
        var dm = DISENO[this.st.orient] || DISENO.h;
        e.w = dm[0]; e.h = dm[1]; e.x = (m.W - e.w) / 2; e.y = (m.H - e.h) / 2; e.cubre = false;
      }
      e.diseno = destino === 'diseno';
      if (destino === 'diseno') this.original = im;
      var habia = destino === 'diseno' && this.cara().els.length > 0;
      this.cambia(function () {
        var cara = self.cara();
        if (destino === 'diseno') cara.els = [];
        cara.els.unshift(e);
        e.id = uid();
        self.st.sel = e.id;
        self.st.plantilla = null;
      });
      this.pestana('elemento');
      this.pintaPaneles();
      if (destino === 'diseno') this.avisa((habia
        ? 'Tu diseño sustituye a lo que había en esta cara (pulsa Deshacer si querías conservarlo). Arrástralo para encuadrarlo.'
        : 'Diseño colocado a su medida (' + (this.st.orient === 'v' ? '59 × 91' : '91 × 59') + ' mm con el margen). Lo que queda fuera de la línea de corte se recorta. Si hace falta, arrástralo para encuadrarlo.') + (this.avisoRes || ''));
      return;
    }
    if (destino === 'logo') {
      this.st.logo = id;
      var hechos = 0;
      ['a', 'r'].forEach(function (c) {
        self.st.caras[c].els.forEach(function (x, i, arr) {
          if (x.rol === 'marca' && x.t === 'text') {
            arr[i] = self.logoEn(x);
            hechos++;
          } else if (x.rol === 'marca' && x.t === 'img') {
            var n = self.logoEn(x); arr[i] = n; hechos++;
          }
        });
      });
      if (hechos) {
        this.cambia(function () {});
        this.pintaPaneles();
        return;
      }
    }
    var lado = Math.min(m.W, m.H) * 0.4;
    var asp = im.w / im.h;
    e.w = asp >= 1 ? lado * asp : lado; e.h = e.w / asp;
    if (e.w > m.W - 2 * SEGURA) { e.w = m.W - 2 * SEGURA; e.h = e.w / asp; }
    e.x = (m.W - e.w) / 2; e.y = (m.H - e.h) / 2;
    if (destino === 'logo') e.rol = 'marca';
    this.anade(e);
  };
  /* convierte un texto de marca en el logo, ocupando su sitio */
  Editor.prototype.logoEn = function (x) {
    var im = this.imgs[this.st.logo];
    var asp = im.w / im.h;
    this.altoDe(x);
    var alto = Math.max(x.h * 1.35, 5), ancho = alto * asp;
    var maxW = x.t === 'text' ? Math.max(x.w, 12) : x.w;
    if (ancho > maxW) { ancho = maxW; alto = ancho / asp; }
    var nx = x.x;
    if (x.alin === 'center') nx = x.x + (x.w - ancho) / 2;
    else if (x.alin === 'right') nx = x.x + x.w - ancho;
    var cy = x.y + x.h / 2;
    return { id: uid(), t: 'img', src: this.st.logo, x: nx, y: cy - alto / 2, w: ancho, h: alto, rot: 0, rol: 'marca', alin: x.alin };
  };
  Editor.prototype.ppp = function (e) {
    var im = this.imgs[e.src];
    if (!im || im.tipo === 'image/svg+xml') return null;
    return Math.round(im.w / (e.w / 25.4));
  };

  /* ------------------------------------------------------------------
     Plantillas
  ------------------------------------------------------------------ */
  var PARES = { 'h-corporativa': 'v-empleado', 'v-empleado': 'h-corporativa', 'h-socio': 'v-evento', 'v-evento': 'h-socio', 'h-marca': 'v-acreditacion', 'v-acreditacion': 'h-marca', 'h-regalo': 'v-evento', 'h-fidelizacion': 'v-acreditacion', 'h-blanco': 'v-blanco', 'v-blanco': 'h-blanco' };
  Editor.prototype.plantillaPar = function (id) { return PARES[id]; };

  Editor.prototype.listaPlantillas = function () {
    return this.st.orient === 'h'
      ? [['h-corporativa', 'Corporativa'], ['h-socio', 'Socio o abonado'], ['h-regalo', 'Tarjeta regalo'], ['h-fidelizacion', 'Fidelización'], ['h-marca', 'Solo marca'], ['h-blanco', 'En blanco']]
      : [['v-acreditacion', 'Acreditación'], ['v-evento', 'Evento'], ['v-empleado', 'Empleado'], ['v-blanco', 'En blanco']];
  };

  Editor.prototype.datosPlantilla = function () {
    var u = this.cfg.usos[this.st.uso] || {};
    return {
      marca: this.st.empresa || this.cfg.textos.marcaEjemplo || 'Tu marca',
      c1: this.st.c1, c2: this.st.c2,
      t1: tintaSobre(this.st.c1), t2: tintaSobre(this.st.c2),
      nombre: this.cfg.textos.nombreEjemplo || 'Lucía Martín',
      cargo: u.cargo || 'Responsable de cuentas',
      web: this.cfg.textos.webEjemplo || 'https://tumarca.com',
      webCorta: (this.cfg.textos.webEjemplo || 'tumarca.com').replace(/^https?:\/\//, ''),
      categoria: u.categoria || 'Staff'
    };
  };

  function T(txt, x, y, w, o) {
    var e = { t: 'text', txt: txt, x: x, y: y, w: w, h: 4, font: 'f1', peso: 400, tam: 9, color: '#0A0A0A', alin: 'left', esp: 0, mayus: false, rot: 0 };
    Object.keys(o || {}).forEach(function (k) { e[k] = o[k]; });
    return e;
  }
  function Rc(x, y, w, h, color, o) {
    var e = { t: 'rect', x: x, y: y, w: w, h: h, color: color, radio: 0, rot: 0 };
    Object.keys(o || {}).forEach(function (k) { e[k] = o[k]; });
    return e;
  }

  Editor.prototype.construyePlantilla = function (id) {
    var d = this.datosPlantilla(), S = SANGRADO;
    var gris = '#5F6368';
    var A = { fondo: '#FFFFFF', els: [] }, Rv = { fondo: '#FFFFFF', els: [] };
    var W, H;
    var qr = function (x, y, w, color, fondo) { return { t: 'qr', url: d.web, x: x, y: y, w: w, h: w, color: color || '#0A0A0A', fondoQR: fondo === undefined ? '#FFFFFF' : fondo, rot: 0, rol: 'web' }; };
    var nfc = function (x, y, w, color) { return { t: 'nfc', x: x, y: y, w: w, h: w, color: color, rot: 0 }; };
    var foto = function (x, y, w, h) { return { t: 'foto', x: x, y: y, w: w, h: h, radio: 1.5, rot: 0 }; };

    if (id === 'h-corporativa') {
      W = 85.6; H = 53.98;
      A.els = [
        T(d.marca, 6, 6, 56, { peso: 700, tam: 11, color: d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1, rol: 'marca' }),
        nfc(73, 6, 6.5, d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1),
        T(d.nombre, 6, 33, 60, { peso: 700, tam: 12, variable: true, rol: 'nombre' }),
        T(d.cargo, 6, 39.6, 60, { tam: 7.5, color: gris, variable: true, rol: 'cargo' }),
        Rc(-S, H - 4, W + 2 * S, 4 + S, d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1)
      ];
      Rv.fondo = d.c1;
      Rv.els = [
        qr(W / 2 - 9.5, 8, 19),
        T('Acerca el móvil o escanea', 6, 31, W - 12, { alin: 'center', tam: 8, peso: 600, color: d.t1 }),
        T(d.webCorta, 6, 36.2, W - 12, { alin: 'center', tam: 7, color: d.t1, rol: 'webtxt' }),
        T(d.marca, 6, 45, W - 12, { alin: 'center', tam: 7, peso: 700, color: d.t1, mayus: true, esp: 0.12, rol: 'marca' })
      ];
    } else if (id === 'h-socio') {
      W = 85.6; H = 53.98;
      A.fondo = d.c2;
      A.els = [
        Rc(-S, -S, 4 + S, H + 2 * S, d.c1),
        T(d.marca, 9, 6.5, 55, { peso: 700, tam: 12, color: d.t2, mayus: true, esp: 0.04, rol: 'marca' }),
        nfc(72.5, 6.5, 6.5, d.t2),
        T(d.cargo || 'Socio', 9, 30.5, 50, { tam: 6.5, peso: 600, color: d.t2, mayus: true, esp: 0.14, rol: 'cargo' }),
        T(d.nombre, 9, 35, 50, { peso: 700, tam: 11.5, color: d.t2, variable: true, rol: 'nombre' }),
        T('Nº 000421', 9, 42, 40, { font: 'f6', tam: 8, color: d.t2, variable: true, rol: 'numero' }),
        qr(64, 32, 15.5)
      ];
      Rv.els = [
        T(d.marca, 6, 6, 50, { peso: 700, tam: 9, color: d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1, rol: 'marca' }),
        T('Tarjeta personal e intransferible.\nPreséntala en el acceso o acércala al lector.\nSi la encuentras, devuélvela en recepción.', 6, 14, 52, { tam: 6.5, color: gris, alto: 1.5 }),
        Rc(6, 41, 40, 0.3, '#0A0A0A'),
        T('Firma del titular', 6, 42.5, 40, { tam: 5.5, color: gris }),
        qr(62, 25, 17.6)
      ];
    } else if (id === 'h-marca') {
      W = 85.6; H = 53.98;
      A.fondo = d.c1;
      A.els = [
        T(d.marca, 6, H / 2 - 4, W - 12, { alin: 'center', peso: 700, tam: 18, color: d.t1, rol: 'marca' }),
        nfc(W - 12.5, H - 12.5, 6.5, d.t1)
      ];
      Rv.els = [
        T(d.nombre, 6, 8, 54, { peso: 700, tam: 12, variable: true, rol: 'nombre' }),
        T(d.cargo, 6, 14.6, 54, { tam: 7.5, color: gris, variable: true, rol: 'cargo' }),
        T('+34 600 000 000\nnombre@tumarca.com\n' + d.webCorta, 6, 33, 50, { tam: 7, alto: 1.5, variable: true }),
        qr(W - 22, H - 22, 16)
      ];
    } else if (id === 'h-regalo') {
      W = 85.6; H = 53.98;
      A.fondo = d.c1;
      A.els = [
        { t: 'elipse', x: 54, y: 18, w: 46, h: 46, color: d.c2, rot: 0 },
        T(d.marca, 6, 6, 50, { peso: 700, tam: 11, color: d.t1, rol: 'marca' }),
        nfc(73, 6, 6.5, d.t2 === d.t1 ? d.t1 : d.t2),
        T('Tarjeta regalo', 6, 29.5, 46, { tam: 8.5, peso: 500, color: d.t1 }),
        T('20 €', 6, 34.5, 46, { tam: 26, peso: 700, color: d.t1, variable: true, rol: 'importe' })
      ];
      Rv.els = [
        T('Cómo usarla', 6, 6, 50, { peso: 700, tam: 9 }),
        T('Preséntala en caja para canjearla.\nAcerca el móvil para ver las condiciones.', 6, 12.5, 52, { tam: 6.5, color: gris, alto: 1.5 }),
        T('Válida hasta 31/12/2027', 6, 27, 52, { tam: 6.5, color: gris, variable: true }),
        T('Nº 0000 0421', 6, 44, 44, { font: 'f6', tam: 8, variable: true, rol: 'numero' }),
        qr(63, 27, 17)
      ];
    } else if (id === 'h-fidelizacion') {
      W = 85.6; H = 53.98;
      var tinta1 = d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1;
      A.els = [
        T(d.marca, 6, 6, 56, { peso: 700, tam: 11, color: tinta1, rol: 'marca' }),
        nfc(73, 6, 6.5, tinta1),
        T('Tarjeta de fidelización', 6, 13.2, 56, { tam: 6.5, color: gris, mayus: true, esp: 0.1 })
      ];
      for (var fi = 0; fi < 2; fi++) for (var co = 0; co < 5; co++) {
        A.els.push({ t: 'elipse', x: 6 + co * 10.6, y: 21 + fi * 11, w: 8.6, h: 8.6, color: fi === 1 && co === 4 ? tinta1 : 'none', borde: 0.35, colorBorde: tinta1, rot: 0 });
      }
      A.els.push(T('Gratis', 6 + 4 * 10.6 - 1, 31.9 + 2.2, 10.6, { alin: 'center', tam: 5.5, peso: 700, color: tintaSobre(tinta1) }));
      A.els.push(T('Con 10 sellos, el siguiente es gratis', 61, 23, 19, { tam: 6, color: gris, alto: 1.35 }));
      A.els.push(Rc(-S, H - 4, W + 2 * S, 4 + S, tinta1));
      Rv.els = [
        T(d.nombre, 6, 8, 54, { peso: 700, tam: 11, variable: true, rol: 'nombre' }),
        T('Nº de cliente 000421', 6, 14.5, 54, { font: 'f6', tam: 7, color: gris, variable: true, rol: 'numero' }),
        T('Acerca la tarjeta al móvil para ver tus puntos y las promociones del mes.', 6, 30, 50, { tam: 6.5, color: gris, alto: 1.45 }),
        qr(W - 22, H - 22, 16)
      ];
    } else if (id === 'v-acreditacion') {
      W = 53.98; H = 85.6;
      A.els = [
        Rc(-S, -S, W + 2 * S, 22 + S, d.c1),
        T(d.marca, 4, 8.5, W - 8, { alin: 'center', peso: 700, tam: 11, color: d.t1, rol: 'marca' }),
        foto(W / 2 - 12, 27, 24, 29),
        T(d.nombre, 3, 60, W - 6, { alin: 'center', peso: 700, tam: 12, variable: true, rol: 'nombre' }),
        T(d.cargo, 3, 66.6, W - 6, { alin: 'center', tam: 7.5, color: gris, variable: true, rol: 'cargo' }),
        Rc(-S, H - 10, W + 2 * S, 10 + S, d.c2),
        T(d.categoria, 3, H - 7, W - 6, { alin: 'center', peso: 700, tam: 8, color: d.t2, mayus: true, esp: 0.2, variable: true, rol: 'categoria' })
      ];
      Rv.els = [
        qr(W / 2 - 12, 12, 24),
        T('Acerca el móvil o escanea', 4, 40, W - 8, { alin: 'center', tam: 7.5, peso: 600 }),
        T('Esta acreditación es personal e intransferible. Llévala siempre visible.', 6, 52, W - 12, { alin: 'center', tam: 6, color: gris, alto: 1.45 }),
        T(d.marca, 4, H - 10, W - 8, { alin: 'center', peso: 700, tam: 8, color: d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1, rol: 'marca' })
      ];
    } else if (id === 'v-evento') {
      W = 53.98; H = 85.6;
      A.fondo = d.c1;
      A.els = [
        T(d.marca, 5, 7, W - 10, { peso: 700, tam: 15, color: d.t1, mayus: true, alto: 1.05, rol: 'marca' }),
        T('Acceso total', 5, 27, W - 10, { peso: 600, tam: 7.5, color: d.t1, mayus: true, esp: 0.14, variable: true, rol: 'categoria' }),
        foto(5, 33, 21, 26),
        T(d.nombre, 5, 62, W - 10, { peso: 700, tam: 12, color: d.t1, variable: true, rol: 'nombre' }),
        T(d.categoria, 5, 68.6, 30, { tam: 7.5, color: d.t1, variable: true, rol: 'cargo' }),
        qr(W - 18, 60, 13),
        Rc(-S, H - 6, W + 2 * S, 6 + S, d.c2)
      ];
      Rv.fondo = d.c2;
      Rv.els = [
        qr(W / 2 - 12, 14, 24),
        T('Acerca el móvil: horarios, mapa y normas', 5, 42, W - 10, { alin: 'center', tam: 7.5, peso: 600, color: d.t2, alto: 1.35 }),
        T(d.marca, 4, H - 12, W - 8, { alin: 'center', peso: 700, tam: 9, color: d.t2, mayus: true, rol: 'marca' })
      ];
    } else if (id === 'v-empleado') {
      W = 53.98; H = 85.6;
      A.els = [
        T(d.marca, 5, 6, 34, { peso: 700, tam: 10, color: d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1, rol: 'marca' }),
        nfc(W - 11, 5.6, 6, d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1),
        foto(5, 17, 26, 32),
        T(d.nombre, 5, 54, W - 10, { peso: 700, tam: 13, variable: true, rol: 'nombre' }),
        T(d.cargo, 5, 61.4, W - 10, { tam: 8, color: gris, variable: true, rol: 'cargo' }),
        T('ID 00421', 5, 67, 30, { font: 'f6', tam: 7.5, color: gris, variable: true, rol: 'numero' }),
        Rc(-S, H - 7, W + 2 * S, 7 + S, d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1)
      ];
      Rv.els = [
        T(d.marca, 5, 7, W - 10, { peso: 700, tam: 9, color: d.c1 === '#FFFFFF' ? '#0A0A0A' : d.c1, rol: 'marca' }),
        T('Tarjeta de empleado. Uso personal.\nAcércala al lector para fichar o abrir puertas.\nSi la encuentras, llama al +34 600 000 000.', 5, 16, W - 10, { tam: 6.5, color: gris, alto: 1.5 }),
        qr(W / 2 - 10, 46, 20)
      ];
    } else {
      W = id === 'v-blanco' ? 53.98 : 85.6; H = id === 'v-blanco' ? 85.6 : 53.98;
    }
    var self = this;
    [A, Rv].forEach(function (c) {
      c.els.forEach(function (e) { e.id = uid(); });
      if (self.st.logo) c.els = c.els.map(function (e) { return e.rol === 'marca' && e.t === 'text' ? self.logoEn(e) : e; });
    });
    return { orient: id.charAt(0), a: A, r: Rv };
  };

  Editor.prototype.aplicaPlantilla = function (id, sinHistoria) {
    var p = this.construyePlantilla(id);
    var self = this;
    var fn = function () {
      self.st.orient = p.orient;
      self.st.caras = { a: p.a, r: p.r };
      self.st.plantilla = id;
      self.st.sel = null;
    };
    if (sinHistoria) { fn(); this.st.empezado = true; this.ocultaInicio(); }
    else this.cambia(fn);
    this.textoCache = {};
    this.dimensiona();
    this.pintaBarra(); this.pintaPaneles();
  };

  /* cambia un color de marca en todo el diseño, sin perder lo que el cliente ha tocado */
  Editor.prototype.recolorea = function (clave, nuevo) {
    var viejo = this.st[clave], self = this;
    if (!hexValido(nuevo) || viejo === nuevo) return;
    var tViejo = tintaSobre(viejo), tNuevo = tintaSobre(nuevo);
    this.cambia(function () {
      self.st[clave] = nuevo;
      ['a', 'r'].forEach(function (c) {
        var cara = self.st.caras[c];
        var fondoEra = cara.fondo;
        if (cara.fondo === viejo) cara.fondo = nuevo;
        cara.els.forEach(function (e) {
          if (e.color === viejo) e.color = nuevo;
          else if (e.t !== 'qr' && e.color === tViejo && tViejo !== tNuevo && (fondoEra === viejo || e.sobre === clave)) e.color = tNuevo;
        });
      });
    });
    this.pintaPaneles();
  };

  /* ------------------------------------------------------------------
     Pantalla de inicio
  ------------------------------------------------------------------ */
  Editor.prototype.ocultaInicio = function () {
    if (this.inicio) this.inicio.hidden = true;
  };
  Editor.prototype.empezar = function (modo) {
    if (modo === 'plantilla') {
      this.aplicaPlantilla(this.st.orient === 'v' ? 'v-acreditacion' : 'h-corporativa');
      this.pestana('diseno');
    } else if (modo === 'subir') {
      this.fileDiseno.click();
    } else {
      this.aplicaPlantilla(this.st.orient === 'v' ? 'v-blanco' : 'h-blanco');
      this.pestana('anadir');
    }
  };

  /* ------------------------------------------------------------------
     Paneles
  ------------------------------------------------------------------ */
  Editor.prototype.pestana = function (t) {
    if (t === 'elemento' && !this.seleccionado()) t = 'anadir';
    this.tabActiva = t;
    $$('[data-tab]', this.raiz).forEach(function (b) {
      var on = b.getAttribute('data-tab') === t;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
    });
    $$('[data-pane]', this.raiz).forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== t; });
    var tabEl = $('[data-tab="elemento"]', this.raiz);
    if (tabEl) tabEl.hidden = !this.seleccionado();
  };

  Editor.prototype.pintaBarra = function () {
    var st = this.st, R = this.raiz;
    $$('[data-cara]', R).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-cara') === st.cara); b.setAttribute('aria-pressed', b.getAttribute('data-cara') === st.cara ? 'true' : 'false'); });
    $$('[data-orient]', R).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-orient') === st.orient); b.setAttribute('aria-pressed', b.getAttribute('data-orient') === st.orient ? 'true' : 'false'); });
    $('[data-accion="deshacer"]', R).disabled = !this.historia.length;
    $('[data-accion="rehacer"]', R).disabled = !this.futuro.length;
    var g = $('[data-accion="guias"]', R);
    g.classList.toggle('is-on', st.guias);
    g.setAttribute('aria-pressed', st.guias ? 'true' : 'false');
    var m = this.medidas();
    var med = $('[data-medida]', R);
    if (med) med.textContent = mmTxt(m.W) + ' × ' + mmTxt(m.H) + ' mm · ' + (st.orient === 'h' ? 'horizontal' : 'vertical');
    this.raiz.setAttribute('data-orient', st.orient);
  };

  Editor.prototype.construyePaneles = function () {
    this.panes = {};
    var self = this;
    $$('[data-pane]', this.raiz).forEach(function (p) { self.panes[p.getAttribute('data-pane')] = p; });
  };

  Editor.prototype.pintaPaneles = function () {
    this.paneDiseno();
    this.paneAnadir();
    this.paneElemento();
    this.panePedido();
    this.pestana(this.tabActiva || 'diseno');
  };

  /* componentes del panel */
  function grupo(titulo, hijos, nota) {
    return el('div', { class: 'ne-g' }, [titulo ? el('p', { class: 'ne-g__t', text: titulo }) : null].concat(hijos).concat(nota ? [el('p', { class: 'ne-nota', text: nota })] : []));
  }
  function campo(etq, control, extra) {
    return el('label', { class: 'ne-campo' + (extra ? ' ' + extra : '') }, [el('span', { text: etq }), control]);
  }
  Editor.prototype.muestras = function (actual, alElegir, conLibre) {
    var self = this;
    var fila = el('div', { class: 'ne-muestras' });
    this.cfg.colores.forEach(function (c) {
      fila.appendChild(el('button', {
        type: 'button', class: 'ne-muestra' + (c.hex.toUpperCase() === (actual || '').toUpperCase() ? ' is-on' : ''),
        style: '--c:' + c.hex, title: c.nombre, 'aria-label': c.nombre,
        onclick: function () { alElegir(c.hex); }
      }));
    });
    if (conLibre !== false) {
      var inp = el('input', { type: 'color', value: hexValido(actual) ? actual : '#000000', 'aria-label': 'Otro color' });
      inp.addEventListener('change', function () { alElegir(inp.value.toUpperCase()); });
      var hex = el('input', { type: 'text', class: 'ne-hex', value: hexValido(actual) ? actual.toUpperCase() : '', placeholder: '#0B62D6', maxlength: 7, 'aria-label': 'Código de color' });
      hex.addEventListener('change', function () {
        var v = hex.value.trim(); if (v.charAt(0) !== '#') v = '#' + v;
        if (hexValido(v)) alElegir(v.toUpperCase()); else hex.value = actual || '';
      });
      fila.appendChild(el('span', { class: 'ne-libre' }, [el('span', { class: 'ne-libre__chip', style: '--c:' + (hexValido(actual) ? actual : '#FFFFFF') }, [inp]), hex]));
    }
    return fila;
  };

  Editor.prototype.paneDiseno = function () {
    var p = this.panes.diseno, self = this, st = this.st;
    if (!p) return;
    p.innerHTML = '';
    p.appendChild(this.selectorMaterial());

    var empresa = el('input', { type: 'text', value: st.empresa, placeholder: this.cfg.textos.marcaEjemplo || 'Tu marca', autocomplete: 'organization' });
    empresa.addEventListener('change', function () {
      var nuevo = empresa.value.trim();
      var viejo = st.empresa || self.cfg.textos.marcaEjemplo || 'Tu marca';
      self.cambia(function () {
        st.empresa = nuevo;
        ['a', 'r'].forEach(function (c) {
          st.caras[c].els.forEach(function (e) {
            if (e.rol === 'marca' && e.t === 'text' && (e.txt === viejo || !e.editado)) e.txt = nuevo || self.cfg.textos.marcaEjemplo || 'Tu marca';
          });
        });
      });
      self.textoCache = {};
      self.render();
    });
    var logoBtn = el('button', { type: 'button', class: 'ne-btn ne-btn--linea', onclick: function () { self.fileLogo.click(); } }, [
      icono('subir'), st.logo ? 'Cambiar logo' : 'Subir logo'
    ]);
    p.appendChild(grupo('Tu marca', [
      campo('Nombre de la empresa', empresa),
      el('div', { class: 'ne-fila' }, [logoBtn, st.logo ? el('span', { class: 'ne-ok', text: (this.imgs[st.logo] || {}).nombre || 'Logo cargado' }) : null])
    ], 'PNG con fondo transparente o SVG. Sustituye al nombre en el diseño.'));

    if (!this.esMetal()) {
      p.appendChild(grupo('Color principal', [this.muestras(st.c1, function (c) { self.recolorea('c1', c); })]));
      p.appendChild(grupo('Color secundario', [this.muestras(st.c2, function (c) { self.recolorea('c2', c); })]));
    }

    var rejilla = el('div', { class: 'ne-plantillas' });
    this.listaPlantillas().forEach(function (pl) {
      var cv = el('canvas', { class: 'ne-pl__cv', width: 10, height: 10 });
      var b = el('button', {
        type: 'button', class: 'ne-pl' + (st.plantilla === pl[0] ? ' is-on' : ''),
        onclick: function () {
          if (st.empezado && st.plantilla !== pl[0] && self.tieneCambios() && !window.confirm('Se sustituirá el diseño actual. ¿Seguimos?')) return;
          self.aplicaPlantilla(pl[0]);
        }
      }, [cv, el('span', { text: pl[1] })]);
      rejilla.appendChild(b);
      requestAnimationFrame(function () { self.miniPlantilla(cv, pl[0]); });
    });
    p.appendChild(grupo('Plantillas', [rejilla], 'Se adaptan a tu nombre, tus colores y tu logo. Después lo cambias todo.'));

    p.appendChild(grupo('¿Ya tienes el diseño hecho?', [
      el('button', { type: 'button', class: 'ne-btn ne-btn--linea ne-btn--ancho', onclick: function () { self.fileDiseno.click(); } }, [
        icono('imagen'), 'Subir diseño para el ' + (st.cara === 'a' ? 'anverso' : 'reverso')
      ])
    ], 'Medida obligatoria: 91 × 59 mm en horizontal o 59 × 91 mm en vertical, es decir, la tarjeta de 86 × 54 mm más 5 mm de margen (a 300 ppp, 1075 × 697 px o 697 × 1075 px). PNG o JPG. Lo colocamos a su medida y lo ajustas con el ratón o el dedo.'));

    if (this.esMetal()) return;
    var fondo = this.cara().fondo;
    p.appendChild(grupo('Fondo del ' + (st.cara === 'a' ? 'anverso' : 'reverso'), [
      this.muestras(fondo, function (c) { self.cambia(function () { self.cara().fondo = c; }); self.pintaPaneles(); }),
      el('button', { type: 'button', class: 'ne-btn ne-btn--texto', onclick: function () { self.fileFondo.click(); } }, [icono('imagen'), 'Poner una foto de fondo'])
    ]));
  };

  Editor.prototype.tieneCambios = function () {
    return this.historia.length > 1;
  };

  Editor.prototype.miniPlantilla = function (cv, id) {
    var p = this.construyePlantilla(id);
    var guarda = { o: this.st.orient, c: this.st.caras };
    this.st.orient = p.orient; this.st.caras = { a: p.a, r: p.r };
    var m = this.medidas();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cw = cv.clientWidth || 120, ch = cv.clientHeight || 90;
    cv.width = cw * dpr; cv.height = ch * dpr;
    var c = cv.getContext('2d');
    c.setTransform(dpr, 0, 0, dpr, 0, 0);
    var k = Math.min((cw - 14) / m.W, (ch - 14) / m.H);
    var ox = (cw - m.W * k) / 2, oy = (ch - m.H * k) / 2;
    c.save(); c.shadowColor = 'rgba(16,24,40,.14)'; c.shadowBlur = 8; c.shadowOffsetY = 2;
    c.beginPath(); redondo(c, ox, oy, m.W * k, m.H * k, RADIO_ESQUINA * k); c.fillStyle = '#fff'; c.fill(); c.restore();
    this.pintaCara(c, 'a', k, ox, oy, 'final');
    c.beginPath(); redondo(c, ox, oy, m.W * k, m.H * k, RADIO_ESQUINA * k);
    c.strokeStyle = 'rgba(10,10,10,.12)'; c.stroke();
    this.st.orient = guarda.o; this.st.caras = guarda.c;
  };

  Editor.prototype.paneAnadir = function () {
    var p = this.panes.anadir, self = this;
    if (!p) return;
    p.innerHTML = '';
    var m = this.medidas();
    var d = this.datosPlantilla();
    var opciones = [
      ['texto', 'Texto', function () {
        self.anade(T('Escribe aquí', SEGURA + 2, m.H / 2 - 3, Math.min(50, m.W - 2 * SEGURA - 4), { tam: 12, peso: 700 }));
        setTimeout(function () { var ta = $('textarea', self.panel); if (ta) { ta.focus(); ta.select(); } }, 30);
      }],
      ['variable', 'Dato por persona', function () {
        self.anade(T('Nombre Apellido', SEGURA + 2, m.H / 2 - 3, Math.min(50, m.W - 2 * SEGURA - 4), { tam: 11, peso: 700, variable: true }));
      }],
      ['imagen', 'Logo o imagen', function () { self.fileImagen.click(); }],
      ['qr', 'Código QR', function () {
        self.anade({ t: 'qr', url: d.web, x: m.W - SEGURA - 18, y: m.H - SEGURA - 18, w: 16, h: 16, color: '#0A0A0A', fondoQR: '#FFFFFF', rot: 0 });
      }],
      this.esMetal() ? null : ['foto', 'Foto por persona', function () {
        self.anade({ t: 'foto', x: m.W / 2 - 11, y: m.H / 2 - 13.5, w: 22, h: 27, radio: 1.5, rot: 0 });
      }],
      ['nfc', 'Icono NFC', function () {
        self.anade({ t: 'nfc', x: m.W - SEGURA - 8, y: SEGURA + 2, w: 6.5, h: 6.5, color: '#0A0A0A', rot: 0 });
      }],
      ['rect', 'Rectángulo', function () {
        self.anade(Rc(m.W / 2 - 15, m.H / 2 - 8, 30, 16, self.st.c1, { radio: 0 }));
      }],
      ['elipse', 'Círculo', function () {
        self.anade({ t: 'elipse', x: m.W / 2 - 8, y: m.H / 2 - 8, w: 16, h: 16, color: self.st.c1, rot: 0 });
      }],
      ['linea', 'Línea', function () {
        self.anade(Rc(SEGURA + 2, m.H / 2, m.W - 2 * SEGURA - 4, 0.4, '#0A0A0A'));
      }]
    ];
    var rej = el('div', { class: 'ne-anadir' });
    opciones.forEach(function (o) {
      if (!o) return;
      rej.appendChild(el('button', { type: 'button', class: 'ne-add', onclick: o[2] }, [icono(o[0]), el('span', { text: o[1] })]));
    });
    p.appendChild(grupo('Añadir al ' + (this.st.cara === 'a' ? 'anverso' : 'reverso'), [rej]));

    /* capas */
    var els = this.cara().els.slice().reverse();
    if (els.length) {
      var lista = el('ol', { class: 'ne-capas' });
      els.forEach(function (e) {
        lista.appendChild(el('li', {}, [el('button', {
          type: 'button', class: 'ne-capa' + (self.st.sel === e.id ? ' is-on' : ''),
          onclick: function () { self.selecciona(e.id); }
        }, [icono(e.t === 'text' ? (e.variable ? 'variable' : 'texto') : e.t === 'img' ? 'imagen' : e.t === 'rect' && e.h < 1 ? 'linea' : e.t), el('span', { text: nombreDe(e) })])]));
      });
      p.appendChild(grupo('Capas', [lista], 'La de arriba de la lista se pinta encima.'));
    }
    p.appendChild(el('p', { class: 'ne-atajos', html: 'Atajos: <kbd>Supr</kbd> borra · <kbd>Ctrl</kbd>+<kbd>D</kbd> duplica · <kbd>Ctrl</kbd>+<kbd>Z</kbd> deshace · flechas para mover (con <kbd>Mayús</kbd> más rápido)' }));
  };

  function nombreDe(e) {
    if (e.t === 'text') return (e.txt || 'Texto').split('\n')[0].slice(0, 28);
    if (e.t === 'img') return e.diseno ? 'Diseño completo' : (e.rol === 'marca' ? 'Logo' : 'Imagen');
    if (e.t === 'qr') return 'Código QR';
    if (e.t === 'foto') return 'Foto por persona';
    if (e.t === 'nfc') return 'Icono NFC';
    if (e.t === 'elipse') return 'Círculo';
    if (e.t === 'rect') return e.h < 1 || e.w < 1 ? 'Línea' : 'Rectángulo';
    return 'Elemento';
  }

  Editor.prototype.paneElemento = function () {
    var p = this.panes.elemento, self = this, e = this.seleccionado();
    if (!p) return;
    p.innerHTML = '';
    if (!e) return;
    var cambia = function (fn) { self.cambia(fn); self.refrescaCampos(); };

    p.appendChild(el('div', { class: 'ne-el-cab' }, [
      el('p', { class: 'ne-el-t', text: nombreDe(e) }),
      el('button', { type: 'button', class: 'ne-btn ne-btn--texto', onclick: function () { self.selecciona(null); } }, ['Listo'])
    ]));

    if (e.t === 'text') {
      var ta = el('textarea', { rows: 3 });
      ta.value = e.txt;
      var antesTxt = null;
      ta.addEventListener('focus', function () { antesTxt = self.instantanea(); });
      ta.addEventListener('input', function () { e.txt = ta.value; e.editado = true; self.textoCache = {}; self.render(); });
      ta.addEventListener('change', function () { self.guardaHistoria(antesTxt); self.paneAnadir(); });
      p.appendChild(grupo(null, [campo('Texto', ta)]));

      var selF = el('select', {});
      this.cfg.fuentes.forEach(function (f) {
        var o = el('option', { value: f.id, text: String(f.nombre || '').replace(/["']/g, '') });
        if (f.id === e.font) o.selected = true;
        selF.appendChild(o);
      });
      selF.addEventListener('change', function () { cambia(function () { e.font = selF.value; self.textoCache = {}; }); });
      var tam = el('input', { type: 'number', min: 3, max: 160, step: 0.5, value: e.tam, 'data-campo': 'tam' });
      tam.addEventListener('change', function () { cambia(function () { e.tam = clamp(parseFloat(tam.value) || e.tam, 3, 160); }); });
      p.appendChild(el('div', { class: 'ne-fila2' }, [campo('Letra', selF), campo('Tamaño (pt)', tam, 'ne-campo--corto')]));

      var estilo = el('div', { class: 'ne-seg' }, [
        boton('Negrita', e.peso >= 600, function () { cambia(function () { e.peso = e.peso >= 600 ? 400 : 700; }); self.paneElemento(); }, 'B'),
        boton('Mayúsculas', e.mayus, function () { cambia(function () { e.mayus = !e.mayus; }); self.paneElemento(); }, 'AA'),
        boton('Izquierda', e.alin === 'left', function () { cambia(function () { e.alin = 'left'; }); self.paneElemento(); }, null, 'al-izq'),
        boton('Centro', e.alin === 'center', function () { cambia(function () { e.alin = 'center'; }); self.paneElemento(); }, null, 'al-cen'),
        boton('Derecha', e.alin === 'right', function () { cambia(function () { e.alin = 'right'; }); self.paneElemento(); }, null, 'al-der')
      ]);
      p.appendChild(grupo('Estilo', [estilo]));

      var esp = el('input', { type: 'range', min: -0.05, max: 0.4, step: 0.01, value: e.esp || 0 });
      var antesEsp;
      esp.addEventListener('pointerdown', function () { antesEsp = self.instantanea(); });
      esp.addEventListener('input', function () { e.esp = parseFloat(esp.value); self.textoCache = {}; self.render(); });
      esp.addEventListener('change', function () { self.guardaHistoria(antesEsp); });
      p.appendChild(grupo(null, [campo('Espaciado entre letras', esp)]));

      if (!this.esMetal()) p.appendChild(grupo('Color', [this.muestras(e.color, function (c) { cambia(function () { e.color = c; }); self.paneElemento(); })]));

      var chk = el('input', { type: 'checkbox' });
      chk.checked = !!e.variable;
      chk.addEventListener('change', function () { cambia(function () { e.variable = chk.checked; }); self.panePedido(); });
      p.appendChild(grupo(null, [el('label', { class: 'ne-check' }, [chk, el('span', {}, [el('strong', { text: 'Cambia en cada tarjeta' }), el('small', { text: 'Nombre, número, cargo… Nos mandas un Excel con los datos y lo imprimimos uno a uno.' })])])]));
    }

    if (e.t === 'img' && this.esMetal()) {
      p.appendChild(el('p', { class: 'ne-nota ne-nota--caja', text: 'En stamping la imagen se convierte en una silueta de un solo metal: si tiene fondo transparente usamos su forma; si no, sus zonas oscuras. Para el mejor resultado, sube el logo en PNG transparente o SVG.' }));
    }
    if (e.t === 'img') {
      var q = this.ppp(e);
      if (q) {
        var bien = q >= 250, justo = q >= 150;
        p.appendChild(el('p', { class: 'ne-calidad ' + (bien ? 'is-ok' : justo ? 'is-justo' : 'is-mal') }, [
          el('strong', { text: q + ' ppp' }),
          bien ? ' · calidad de imprenta' : justo ? ' · se verá bien, pero mejor con más resolución' : ' · resolución baja: se verá borrosa al imprimir'
        ]));
      }
      var zoom = el('input', { type: 'range', min: 10, max: 400, step: 1, value: 100 });
      var base = { w: e.w, h: e.h, cx: e.x + e.w / 2, cy: e.y + e.h / 2 }, antesZ;
      zoom.addEventListener('pointerdown', function () { antesZ = self.instantanea(); base = { w: e.w, h: e.h, cx: e.x + e.w / 2, cy: e.y + e.h / 2 }; zoom.value = 100; });
      zoom.addEventListener('input', function () {
        var f = zoom.value / 100;
        e.w = base.w * f; e.h = base.h * f; e.x = base.cx - e.w / 2; e.y = base.cy - e.h / 2; e.cubre = false;
        self.render();
      });
      zoom.addEventListener('change', function () { self.guardaHistoria(antesZ); zoom.value = 100; base = { w: e.w, h: e.h, cx: e.x + e.w / 2, cy: e.y + e.h / 2 }; });
      p.appendChild(grupo('Encuadre', [
        campo('Zoom', zoom),
        el('div', { class: 'ne-seg ne-seg--texto' }, [
          boton('Cubrir hasta el sangrado', false, function () { cambia(function () { self.cubre(e, 'cubrir'); }); }, 'A sangre'),
          boton('Que se vea entera', false, function () { cambia(function () { self.cubre(e, 'ajustar'); }); }, 'Entera'),
          boton('Girar 90°', false, function () { cambia(function () { e.rot = ((e.rot || 0) + 90) % 360; }); }, 'Girar 90°')
        ])
      ], 'Arrastra la imagen sobre la tarjeta para moverla.'));
      var op = el('input', { type: 'range', min: 0.1, max: 1, step: 0.05, value: e.opacidad === undefined ? 1 : e.opacidad });
      var antesO;
      op.addEventListener('pointerdown', function () { antesO = self.instantanea(); });
      op.addEventListener('input', function () { e.opacidad = parseFloat(op.value); self.render(); });
      op.addEventListener('change', function () { self.guardaHistoria(antesO); });
      p.appendChild(grupo(null, [campo('Opacidad', op)]));
    }

    if (e.t === 'qr') {
      var url = el('input', { type: 'url', value: e.url || '', placeholder: 'https://tumarca.com', inputmode: 'url' });
      url.addEventListener('change', function () {
        var v = url.value.trim();
        if (v && !/^[a-z]+:/i.test(v)) v = 'https://' + v;
        cambia(function () { e.url = v; });
        url.value = v;
        self.paneElemento();
      });
      var lado = el('input', { type: 'number', min: 8, max: 60, step: 0.5, value: redondea(e.w, 1), 'data-campo': 'lado' });
      lado.addEventListener('change', function () {
        var v = clamp(parseFloat(lado.value) || e.w, 8, 60);
        cambia(function () { var cx = e.x + e.w / 2, cy = e.y + e.h / 2; e.w = e.h = v; e.x = cx - v / 2; e.y = cy - v / 2; });
      });
      p.appendChild(grupo('Código QR', [campo('Enlace o texto', url), campo('Lado (mm)', lado, 'ne-campo--corto')],
        'El QR apunta siempre a esta dirección: si lo pones a un dominio tuyo, podrás cambiar el destino más adelante sin reimprimir.'));
      var avisos = [];
      if (e.w < 14) avisos.push('Con menos de 14 mm de lado cuesta escanearlo desde lejos.');
      var fondoReal = e.fondoQR || this.cara().fondo;
      if (contraste(e.color || '#0A0A0A', fondoReal) < 4) avisos.push('Poco contraste entre el QR y su fondo: puede no leerse.');
      if (luminancia(e.color || '#000') > luminancia(fondoReal)) avisos.push('El QR claro sobre fondo oscuro no lo leen todos los móviles. Mejor oscuro sobre claro.');
      if (avisos.length) p.appendChild(el('div', { class: 'ne-avisos' }, avisos.map(function (a) { return el('p', { text: a }); })));
      if (this.esMetal()) { p.appendChild(el('p', { class: 'ne-nota ne-nota--caja', text: 'En stamping el QR sale en metal sobre el negro. Lo leen la mayoría de móviles actuales, pero no todos: si es importante que lo escanee cualquiera, ponlo en la tarjeta blanca.' })); }
      var chkF = el('input', { type: 'checkbox' }); chkF.checked = !!e.fondoQR;
      chkF.addEventListener('change', function () { cambia(function () { e.fondoQR = chkF.checked ? '#FFFFFF' : null; }); self.paneElemento(); });
      if (!this.esMetal()) p.appendChild(grupo('Color del QR', [
        this.muestras(e.color, function (c) { cambia(function () { e.color = c; }); self.paneElemento(); }),
        el('label', { class: 'ne-check ne-check--simple' }, [chkF, el('span', { text: 'Recuadro blanco detrás (recomendado)' })])
      ]));
    }

    if (e.t === 'rect' || e.t === 'elipse' || e.t === 'foto' || e.t === 'nfc') {
      if (e.t === 'foto' && this.esMetal()) {
        p.appendChild(el('p', { class: 'ne-avisos', text: 'La tarjeta negra con stamping no lleva fotos: el metal es un solo color. Quita este hueco o pasa a la tarjeta blanca a todo color.' }));
      } else if (e.t === 'foto') {
        p.appendChild(el('p', { class: 'ne-nota ne-nota--caja', text: 'Aquí irá la foto de cada persona. Al confirmar el pedido nos mandas las fotos (o un Excel con el nombre del archivo de cada una) y las colocamos tarjeta a tarjeta.' }));
      }
      if (e.t !== 'foto' && !this.esMetal()) {
        p.appendChild(grupo('Color', [this.muestras(e.color, function (c) { cambia(function () { e.color = c; }); self.paneElemento(); })]));
      }
      if (e.t === 'rect' || e.t === 'foto') {
        var rad = el('input', { type: 'range', min: 0, max: 20, step: 0.5, value: e.radio || 0 });
        var antesR;
        rad.addEventListener('pointerdown', function () { antesR = self.instantanea(); });
        rad.addEventListener('input', function () { e.radio = parseFloat(rad.value); self.render(); });
        rad.addEventListener('change', function () { self.guardaHistoria(antesR); });
        p.appendChild(grupo(null, [campo('Esquinas redondeadas', rad)]));
      }
    }

    /* medidas y posición */
    var fx = numero('X', e.x, function (v) { cambia(function () { e.x = v; }); }, 'x');
    var fy = numero('Y', e.y, function (v) { cambia(function () { e.y = v; }); }, 'y');
    var fw = numero('Ancho', e.w, function (v) {
      cambia(function () {
        v = Math.max(0.3, v);
        if (e.t === 'img' || e.t === 'qr' || e.t === 'nfc') { var asp = e.w / e.h; e.h = v / asp; }
        e.w = v;
      });
    }, 'w');
    var fr = numero('Giro (°)', e.rot || 0, function (v) { cambia(function () { e.rot = ((v + 540) % 360) - 180; }); }, 'rot', 1);
    p.appendChild(grupo('Posición en mm', [el('div', { class: 'ne-fila4' }, [fx, fy, fw, fr])]));

    p.appendChild(el('div', { class: 'ne-seg ne-seg--texto' }, [
      boton('Centrar en horizontal', false, function () { self.centra('x'); }, 'Centrar ↔'),
      boton('Centrar en vertical', false, function () { self.centra('y'); }, 'Centrar ↕')
    ]));
    p.appendChild(el('div', { class: 'ne-seg ne-seg--texto' }, [
      boton('Traer al frente', false, function () { self.capa('frente'); self.paneAnadir(); }, 'Al frente'),
      boton('Enviar al fondo', false, function () { self.capa('fondo'); self.paneAnadir(); }, 'Al fondo'),
      boton('Duplicar', false, function () { self.duplica(); }, 'Duplicar')
    ]));
    p.appendChild(el('button', { type: 'button', class: 'ne-btn ne-btn--peligro ne-btn--ancho', onclick: function () { self.borra(); } }, [icono('papelera'), 'Eliminar']));
  };

  function numero(etq, valor, alCambiar, clave, dec) {
    var i = el('input', { type: 'number', step: dec ? 1 : 0.5, value: redondea(valor, dec === undefined ? 1 : 0), 'data-campo': clave });
    i.addEventListener('change', function () { var v = parseFloat(i.value); if (!isNaN(v)) alCambiar(v); });
    return campo(etq, i, 'ne-campo--corto');
  }
  function boton(titulo, on, fn, texto, ico) {
    return el('button', { type: 'button', class: 'ne-segb' + (on ? ' is-on' : ''), title: titulo, 'aria-label': titulo, 'aria-pressed': on ? 'true' : 'false', onclick: fn }, [ico ? icono(ico) : null, texto ? el('span', { text: texto }) : null]);
  }

  /* refresca los números del panel mientras se arrastra, sin reconstruirlo */
  Editor.prototype.refrescaCampos = function () {
    var e = this.seleccionado(), p = this.panes.elemento;
    if (!e || !p) return;
    var v = { x: e.x, y: e.y, w: e.w, rot: e.rot || 0, tam: e.tam, lado: e.w };
    $$('[data-campo]', p).forEach(function (i) {
      var k = i.getAttribute('data-campo');
      if (document.activeElement === i || v[k] === undefined) return;
      i.value = redondea(v[k], k === 'rot' ? 0 : 1);
    });
  };

  /* ------------------------------------------------------------------
     Pedido
  ------------------------------------------------------------------ */
  Editor.prototype.datosVariables = function () {
    var nombres = [], self = this, fotos = false;
    ['a', 'r'].forEach(function (c) {
      self.st.caras[c].els.forEach(function (e) {
        if (e.t === 'foto') fotos = true;
        if (e.t === 'text' && e.variable) {
          var r = { nombre: 'Nombre', cargo: 'Cargo', numero: 'Número', categoria: 'Categoría' }[e.rol] || (e.txt || '').split('\n')[0].slice(0, 24);
          if (nombres.indexOf(r) < 0) nombres.push(r);
        }
      });
    });
    if (fotos) nombres.push('Foto');
    return nombres;
  };

  Editor.prototype.material = function () {
    var ms = this.cfg.materiales, st = this.st;
    for (var i = 0; i < ms.length; i++) if (ms[i].clave === st.material) return ms[i];
    return ms[0];
  };
  Editor.prototype.caras = function () {
    return this.st.caras.r.els.length ? 2 : 1;
  };
  Editor.prototype.cantidad = function () {
    var st = this.st;
    if (this.cfg.soloPresupuesto) {
      if (st.cantidad === 'otra') return parseInt(st.cantidadLibre, 10) || 0;
      return parseInt(st.cantidad, 10) || 0;
    }
    if (this.esMetal()) return parseInt(st.cantMetal, 10) || 0;
    if (st.cantidad === 'otra') return parseInt(st.cantidadLibre, 10) || 0;
    return st.cantidad;
  };
  /* la variante que se puede comprar con lo elegido, o null si va a presupuesto */
  Editor.prototype.variante = function () {
    var st = this.st, mat = this.material(), n = this.cantidad();
    if (this.cfg.soloPresupuesto) return null;
    if (!mat || !mat.variantes || !mat.variantes.length) return null;
    if (st.chip !== this.cfg.chipConPrecio) return null;
    if (!n) return null;
    var vs = mat.variantes, i;
    if (mat.clave === 'metal') {
      if (n > (mat.maximo || 100)) return null;
      var caras = this.caras();
      for (i = 0; i < vs.length; i++) if (vs[i].metal === st.metal && vs[i].caras === caras && vs[i].disponible) return vs[i];
      return null;
    }
    if (st.cantidad === 'otra') return null;
    for (i = 0; i < vs.length; i++) if (vs[i].cantidad === n && vs[i].disponible) return vs[i];
    return null;
  };
  Editor.prototype.motivoPresupuesto = function () {
    var st = this.st, mat = this.material(), n = this.cantidad();
    if (this.cfg.soloPresupuesto) return 'todo';
    if (st.chip !== this.cfg.chipConPrecio) return 'chip';
    if (!mat.variantes || !mat.variantes.length) return 'sinprecio';
    if (mat.clave === 'metal' && n > (mat.maximo || 100)) return 'cantidad';
    if (mat.clave !== 'metal' && st.cantidad === 'otra') return 'cantidad';
    return 'sinprecio';
  };

  /* selector de tipo de tarjeta: va en Diseño y en Pedido */
  Editor.prototype.selectorMaterial = function () {
    var self = this, st = this.st;
    var caja = el('div', { class: 'ne-mats', role: 'radiogroup', 'aria-label': 'Tipo de tarjeta' });
    this.cfg.materiales.forEach(function (m) {
      var desde = '';
      if (!self.cfg.soloPresupuesto && m.variantes && m.variantes.length) {
        var min = Math.min.apply(null, m.variantes.map(function (v) { return m.clave === 'metal' ? v.precio : v.precio / v.cantidad; }));
        desde = m.clave === 'metal' ? 'Desde ' + euros(min) + ' de 1 a ' + (m.maximo || 100) : 'Desde ' + euros(min) + '/ud';
      }
      caja.appendChild(el('button', {
        type: 'button', role: 'radio', class: 'ne-mat ne-mat--' + m.clave + (st.material === m.clave ? ' is-on' : ''),
        'aria-checked': st.material === m.clave ? 'true' : 'false',
        onclick: function () {
          if (st.material === m.clave) return;
          st.material = m.clave;
          self.mascaras = {};
          self.render(); self.pintaPaneles(); self.programaGuardado();
        }
      }, [el('span', { class: 'ne-mat__m', 'aria-hidden': 'true' }), el('span', { class: 'ne-mat__t' }, [el('strong', { text: m.nombre }), el('small', { text: m.texto }), desde ? el('em', { text: desde }) : null])]));
    });
    var hijos = [caja];
    if (this.esMetal()) {
      var metales = el('div', { class: 'ne-seg' });
      [['oro', 'Oro'], ['plata', 'Plata']].forEach(function (mt) {
        metales.appendChild(boton(mt[1], st.metal === mt[0], function () {
          st.metal = mt[0]; self.mascaras = {}; self.render(); self.pintaPaneles(); self.programaGuardado();
        }, mt[1]));
      });
      hijos.push(campo('Metal', metales));
    }
    return grupo('Tipo de tarjeta', hijos, this.esMetal() ? this.cfg.textos.notaMetal : null);
  };

  Editor.prototype.panePedido = function () {
    var p = this.panes.pedido, self = this, st = this.st, cfg = this.cfg;
    if (!p) return;
    p.innerHTML = '';

    p.appendChild(this.selectorMaterial());

    var selU = el('select', {});
    cfg.usos.forEach(function (u, i) {
      var o = el('option', { value: i, text: u.etiqueta });
      if (i === st.uso) o.selected = true;
      selU.appendChild(o);
    });
    selU.addEventListener('change', function () {
      st.uso = parseInt(selU.value, 10);
      var u = cfg.usos[st.uso];
      if (u && u.chip) st.chip = u.chip;
      self.panePedido();
      self.programaGuardado();
    });
    p.appendChild(grupo(null, [campo('¿Para qué es la tarjeta?', selU)]));

    var chips = el('div', { class: 'ne-chips', role: 'radiogroup', 'aria-label': 'Chip' });
    cfg.chips.forEach(function (c) {
      chips.appendChild(el('button', {
        type: 'button', role: 'radio', class: 'ne-chip' + (st.chip === c.clave ? ' is-on' : ''), 'aria-checked': st.chip === c.clave ? 'true' : 'false',
        onclick: function () { st.chip = c.clave; self.panePedido(); self.programaGuardado(); }
      }, [el('span', { class: 'ne-chip__cab' }, [el('strong', { text: c.nombre }), cfg.soloPresupuesto ? null : el('small', { class: c.clave === cfg.chipConPrecio ? 'is-precio' : '', text: c.clave === cfg.chipConPrecio ? 'Con precio' : 'Presupuesto' })]), el('small', { text: c.tecnologia }), el('span', { text: c.texto })]));
    });
    p.appendChild(grupo('Chip', [chips], cfg.textos.notaChip));

    var vars = this.datosVariables();
    if (vars.length) {
      p.appendChild(el('div', { class: 'ne-vars' }, [
        el('p', {}, [el('strong', { text: 'Cambia en cada tarjeta: ' }), vars.join(', ')]),
        el('p', { class: 'ne-nota', text: 'Al confirmar te pedimos un Excel con una fila por tarjeta' + (vars.indexOf('Foto') >= 0 ? ' y las fotos' : '') + '. Antes de imprimir te enseñamos la prueba.' })
      ]));
    }

    var mat = this.material();
    var grupoCant = [];
    if (cfg.soloPresupuesto) {
      var cp = el('div', { class: 'ne-cant' });
      (cfg.cantidades || [10, 25, 50, 100, 250, 500]).forEach(function (n) {
        cp.appendChild(el('button', {
          type: 'button', class: 'ne-cantb' + (st.cantidad === n ? ' is-on' : ''), 'aria-pressed': st.cantidad === n ? 'true' : 'false',
          onclick: function () { st.cantidad = n; self.panePedido(); self.programaGuardado(); }
        }, [el('strong', { text: n.toLocaleString('es-ES') }), el('small', { text: 'tarjetas' })]));
      });
      cp.appendChild(el('button', {
        type: 'button', class: 'ne-cantb' + (st.cantidad === 'otra' ? ' is-on' : ''),
        onclick: function () { st.cantidad = 'otra'; self.panePedido(); setTimeout(function () { var i = $('[data-cant-libre]', p); if (i) i.focus(); }, 20); }
      }, [el('strong', { text: 'Otra' }), el('small', { text: 'cantidad' })]));
      grupoCant.push(cp);
      if (st.cantidad === 'otra') {
        var lp = el('input', { type: 'number', min: 1, step: 1, value: st.cantidadLibre, placeholder: 'Ej.: 340', 'data-cant-libre': '' });
        lp.addEventListener('input', function () { st.cantidadLibre = lp.value; self.pintaTotal(); self.programaGuardado(); });
        grupoCant.push(campo('¿Cuántas?', lp));
      }
    } else if (mat.clave === 'metal') {
      var max = mat.maximo || 100;
      var rap = el('div', { class: 'ne-cant ne-cant--metal' });
      [10, 25, 50, max].forEach(function (n) {
        rap.appendChild(el('button', {
          type: 'button', class: 'ne-cantb' + (parseInt(st.cantMetal, 10) === n ? ' is-on' : ''),
          onclick: function () { st.cantMetal = n; self.panePedido(); self.programaGuardado(); }
        }, [el('strong', { text: String(n) }), el('small', { text: 'tarjetas' })]));
      });
      var libreM = el('input', { type: 'number', min: 1, step: 1, value: st.cantMetal, 'aria-label': 'Número de tarjetas' });
      libreM.addEventListener('input', function () { st.cantMetal = libreM.value; self.pintaTotal(); self.programaGuardado(); $$('.ne-cant--metal .ne-cantb', p).forEach(function (b) { b.classList.remove('is-on'); }); });
      grupoCant = [rap, campo('Número de tarjetas (de 1 a ' + max + ' mismo precio)', libreM)];
    } else {
      var cant = el('div', { class: 'ne-cant' });
      var vs = (mat.variantes || []).slice().sort(function (x, y) { return x.cantidad - y.cantidad; });
      vs.forEach(function (v) {
        var n = v.cantidad;
        cant.appendChild(el('button', {
          type: 'button', class: 'ne-cantb' + (st.cantidad === n ? ' is-on' : ''), 'aria-pressed': st.cantidad === n ? 'true' : 'false',
          onclick: function () { st.cantidad = n; self.panePedido(); self.programaGuardado(); }
        }, [el('strong', { text: n.toLocaleString('es-ES') }), el('small', { text: euros(v.precio / n) + '/ud' })]));
      });
      cant.appendChild(el('button', {
        type: 'button', class: 'ne-cantb' + (st.cantidad === 'otra' ? ' is-on' : ''),
        onclick: function () { st.cantidad = 'otra'; self.panePedido(); setTimeout(function () { var i = $('[data-cant-libre]', p); if (i) i.focus(); }, 20); }
      }, [el('strong', { text: 'Otra' }), el('small', { text: 'presupuesto' })]));
      grupoCant.push(cant);
      if (st.cantidad === 'otra') {
        var libre = el('input', { type: 'number', min: 1, step: 1, value: st.cantidadLibre, placeholder: 'Ej.: 340', 'data-cant-libre': '' });
        libre.addEventListener('input', function () { st.cantidadLibre = libre.value; self.pintaTotal(); self.programaGuardado(); });
        grupoCant.push(campo('¿Cuántas?', libre));
      }
    }
    p.appendChild(grupo('Cantidad', grupoCant));

    p.appendChild(el('div', { class: 'ne-total', 'data-total': '' }));
    p.appendChild(el('div', { class: 'ne-sec' }, [
      el('button', { type: 'button', class: 'ne-btn ne-btn--texto', onclick: function () { self.descarga(); } }, [icono('subir'), 'Descargar mi diseño (PNG)'])
    ]));
    this.pintaTotal();
  };

  Editor.prototype.pintaTotal = function () {
    var cfg = this.cfg, n = this.cantidad(), self = this, mat = this.material();
    var v = this.variante();
    var motivo = v ? null : this.motivoPresupuesto();
    $$('[data-total]', this.raiz).forEach(function (caja) {
      caja.innerHTML = '';
      var compacto = caja.hasAttribute('data-compacto');
      if (v) {
        var etq = mat.clave === 'metal'
          ? n + ' tarjeta' + (n === 1 ? '' : 's') + ' · ' + (self.caras() === 2 ? 'dos caras' : 'una cara')
          : n.toLocaleString('es-ES') + ' tarjeta' + (n === 1 ? '' : 's');
        caja.appendChild(el('div', { class: 'ne-total__fila' }, [el('span', { text: etq }), el('strong', { text: euros(v.precio) })]));
        if (!compacto) {
          caja.appendChild(el('p', { class: 'ne-nota', text: euros(v.precio / n) + ' por tarjeta · IVA incluido' + (cfg.textos.notaPrecio ? ' · ' + cfg.textos.notaPrecio : '') }));
          if (mat.clave === 'metal' && self.caras() === 1 && mat.variantes.some(function (x) { return x.caras === 2; })) {
            caja.appendChild(el('p', { class: 'ne-nota', text: 'Si diseñas también el reverso, pasa a la tarifa de dos caras.' }));
          }
        }
      } else {
        var txt = {
          todo: 'Te mandamos precio y plazo para este diseño',
          chip: 'Este chip va a presupuesto',
          cantidad: 'Esta cantidad va a presupuesto',
          sinprecio: 'A presupuesto'
        }[motivo] || 'A presupuesto';
        caja.appendChild(el('div', { class: 'ne-total__fila' }, [
          el('span', { text: n ? n.toLocaleString('es-ES') + ' tarjeta' + (n === 1 ? '' : 's') : 'Elige la cantidad' }),
          el('strong', { text: motivo === 'todo' ? 'Sin compromiso' : 'Presupuesto' })
        ]));
        if (!compacto) caja.appendChild(el('p', { class: 'ne-nota', text: txt + '. ' + (cfg.textos.notaPresupuesto || '') }));
      }
    });
    $$('[data-cta]', this.raiz).forEach(function (b) {
      b.classList.toggle('is-wa', !v);
      b.innerHTML = '';
      if (v) b.appendChild(document.createTextNode((cfg.textos.ctaCarrito || 'Añadir al carrito') + ' · ' + euros(v.precio)));
      else b.appendChild(document.createTextNode(cfg.textos.ctaWhatsapp || 'Pedir presupuesto por WhatsApp'));
      b.disabled = !n;
      b.onclick = function () { if (v) self.alCarrito(v); else self.aWhatsapp(); };
    });
  };

  /* ------------------------------------------------------------------
     Exportar
  ------------------------------------------------------------------ */
  Editor.prototype.exporta = function (claveCara, ppp) {
    var m = this.medidas(), k = (ppp || PPP) / 25.4, S = SANGRADO;
    var cv = document.createElement('canvas');
    cv.width = Math.round((m.W + 2 * S) * k);
    cv.height = Math.round((m.H + 2 * S) * k);
    var c = cv.getContext('2d');
    this.pintaCara(c, claveCara, k, S * k, S * k, 'export');
    return cv;
  };
  Editor.prototype.blob = function (cv) {
    return new Promise(function (ok) { cv.toBlob(function (b) { ok(b); }, 'image/png'); });
  };
  Editor.prototype.descarga = function () {
    var self = this;
    ['a', 'r'].forEach(function (c, i) {
      setTimeout(function () {
        var cv = self.exporta(c);
        var a = document.createElement('a');
        a.download = 'nfcard-' + (c === 'a' ? 'anverso' : 'reverso') + '.png';
        a.href = cv.toDataURL('image/png');
        document.body.appendChild(a); a.click(); a.remove();
      }, i * 400);
    });
  };

  Editor.prototype.resumen = function () {
    var st = this.st, cfg = this.cfg, self = this;
    var lineas = [];
    var u = cfg.usos[st.uso] || {};
    var chip = cfg.chips.filter(function (c) { return c.clave === st.chip; })[0] || {};
    if (st.empresa) lineas.push('Empresa: ' + st.empresa);
    lineas.push('Uso: ' + (u.etiqueta || ''));
    lineas.push('Tarjeta: ' + this.material().nombre + (this.esMetal() ? ' (' + (st.metal === 'plata' ? 'plata' : 'oro') + ', ' + (this.caras() === 2 ? 'dos caras' : 'una cara') + ')' : ''));
    lineas.push('Formato: CR80 ' + (st.orient === 'h' ? 'horizontal' : 'vertical'));
    lineas.push('Chip: ' + (chip.nombre || st.chip) + (chip.tecnologia ? ' (' + chip.tecnologia + ')' : ''));
    lineas.push('Cantidad: ' + (this.cantidad() || 'por decidir'));
    ['a', 'r'].forEach(function (c) {
      var cara = st.caras[c];
      var partes = ['fondo ' + cara.fondo];
      cara.els.forEach(function (e) {
        if (e.t === 'text') partes.push('"' + (e.txt || '').replace(/\n/g, ' / ') + '"' + (e.variable ? ' (cambia en cada una)' : ''));
        else if (e.t === 'qr') partes.push('QR a ' + e.url);
        else if (e.t === 'img') partes.push(e.diseno ? 'diseño completo subido' : (e.rol === 'marca' ? 'logo' : 'imagen'));
        else if (e.t === 'foto') partes.push('foto de cada persona');
        else if (e.t === 'nfc') partes.push('icono NFC');
      });
      lineas.push((c === 'a' ? 'Anverso: ' : 'Reverso: ') + partes.join(', '));
    });
    var vars = this.datosVariables();
    if (vars.length) lineas.push('Cambia en cada tarjeta: ' + vars.join(', '));
    if (st.logo || this.hayImagenes()) lineas.push('Os mando el logo / las imágenes al responder');
    return lineas;
  };
  Editor.prototype.hayImagenes = function () {
    var st = this.st;
    return ['a', 'r'].some(function (c) { return st.caras[c].els.some(function (e) { return e.t === 'img'; }); });
  };

  Editor.prototype.aPresupuesto = function () {
    var st = this.st, cfg = this.cfg;
    var u = cfg.usos[st.uso] || {};
    var vars = this.datosVariables();
    var datos = [];
    if (vars.indexOf('Nombre') >= 0) datos.push('nombre');
    if (vars.indexOf('Foto') >= 0) datos.push('foto');
    if (vars.indexOf('Número') >= 0) datos.push('numero');
    var q = new URLSearchParams();
    if (st.empresa) q.set('empresa', st.empresa);
    if (u.opcion) q.set('uso', u.opcion);
    q.set('color', st.c1);
    q.set('chip', st.chip);
    if (datos.length) q.set('datos', datos.join(','));
    q.set('orientacion', st.orient);
    if (this.cantidad()) q.set('cantidad', String(this.cantidad()));
    q.set('resumen', this.resumen().join('\n'));
    this.guardaYa();
    window.location.href = (cfg.urlPresupuesto || '/pages/nfc-a-medida') + '?' + q.toString() + '#nfcard-presupuesto';
  };

  Editor.prototype.aWhatsapp = function () {
    var lineas = ['Hola, quiero presupuesto de esta tarjeta NFC diseñada en la web:'].concat(this.resumen().map(function (l) { return '· ' + l; }));
    lineas.push('', 'Os mando la imagen del diseño por aquí.');
    this.guardaYa();
    var url = 'https://wa.me/' + (this.cfg.whatsapp || '') + '?text=' + encodeURIComponent(lineas.join('\n'));
    var w = window.open(url, '_blank', 'noopener');
    if (!w) window.location.href = url;
    this.avisa('Si quieres enseñarnos el diseño, pulsa «Descargar mi diseño» y adjunta las imágenes en el chat.');
  };

  Editor.prototype.alCarrito = function (v) {
    var self = this, st = this.st, cfg = this.cfg, mat = this.material();
    var botones = $$('[data-cta]', this.raiz);
    botones.forEach(function (b) { b.disabled = true; b.textContent = 'Preparando tu diseño…'; });
    var fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', '1');
    var u = cfg.usos[st.uso] || {};
    var chip = cfg.chips.filter(function (c) { return c.clave === st.chip; })[0] || {};
    if (mat.clave === 'metal') fd.append('properties[Tarjetas]', String(this.cantidad()));
    fd.append('properties[Uso]', u.etiqueta || '');
    fd.append('properties[Orientación]', st.orient === 'h' ? 'Horizontal' : 'Vertical');
    fd.append('properties[Chip]', (chip.nombre || st.chip) + (chip.tecnologia ? ' · ' + chip.tecnologia : ''));
    if (st.empresa) fd.append('properties[Empresa]', st.empresa);
    var vars = this.datosVariables();
    if (vars.length) fd.append('properties[Cambia en cada tarjeta]', vars.join(', '));
    var qrs = [];
    ['a', 'r'].forEach(function (c) { st.caras[c].els.forEach(function (e) { if (e.t === 'qr' && e.url && qrs.indexOf(e.url) < 0) qrs.push(e.url); }); });
    if (qrs.length) fd.append('properties[QR]', qrs.join(' · '));
    fd.append('properties[_Resumen]', this.resumen().join(' | '));
    var exportar = [this.blob(this.exporta('a'))];
    if (this.caras() === 2 || mat.clave !== 'metal') exportar.push(this.blob(this.exporta('r')));
    Promise.all(exportar).then(function (b) {
      fd.append('properties[Anverso]', new File([b[0]], 'anverso.png', { type: 'image/png' }));
      if (b[1]) fd.append('properties[Reverso]', new File([b[1]], 'reverso.png', { type: 'image/png' }));
      if (self.original && self.original.archivo) fd.append('properties[Archivo original]', self.original.archivo);
      if (st.logo && self.imgs[st.logo] && self.imgs[st.logo].archivo) fd.append('properties[Logo]', self.imgs[st.logo].archivo);
      return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('carrito');
      return r.json();
    }).then(function () {
      self.guardaYa();
      ['cart:update', 'cart:updated'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
      var cajon = document.getElementById('cart-drawer');
      if (cajon && typeof cajon.open === 'function') { cajon.open(); self.pintaTotal(); }
      else window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    }).catch(function () {
      self.avisa('No hemos podido añadirlo al carrito. Prueba otra vez o pídenos presupuesto por WhatsApp.');
      self.pintaTotal();
    });
  };

  /* ------------------------------------------------------------------
     Avisos, guardado y parámetros de la URL
  ------------------------------------------------------------------ */
  Editor.prototype.avisa = function (txt) {
    if (!this.aviso) return;
    var a = this.aviso;
    a.textContent = txt;
    a.hidden = false;
    clearTimeout(this._av);
    this._av = setTimeout(function () { a.hidden = true; }, 6500);
  };

  Editor.prototype.programaGuardado = function () {
    var self = this;
    clearTimeout(this._g);
    this._g = setTimeout(function () { self.guardaYa(); }, 700);
  };
  Editor.prototype.guardaYa = function () {
    if (!this.st.empezado) return;
    var st = this.st, self = this;
    var datos = { st: {}, imgs: {} };
    ['orient', 'cara', 'caras', 'plantilla', 'empresa', 'c1', 'c2', 'logo', 'chip', 'uso', 'material', 'metal', 'cantidad', 'cantidadLibre', 'cantMetal', 'empezado'].forEach(function (k) { datos.st[k] = st[k]; });
    var usadas = {};
    ['a', 'r'].forEach(function (c) { st.caras[c].els.forEach(function (e) { if (e.t === 'img') usadas[e.src] = 1; }); });
    if (st.logo) usadas[st.logo] = 1;
    Object.keys(usadas).forEach(function (id) {
      var im = self.imgs[id];
      if (im) datos.imgs[id] = { src: im.src, nombre: im.nombre, w: im.w, h: im.h, tipo: im.tipo };
    });
    try {
      localStorage.setItem(CLAVE_GUARDADO, JSON.stringify(datos));
    } catch (err) {
      try { datos.imgs = {}; localStorage.setItem(CLAVE_GUARDADO, JSON.stringify(datos)); } catch (err2) {}
    }
  };
  Editor.prototype.leerGuardado = function () {
    var raw = null, self = this;
    try { raw = localStorage.getItem(CLAVE_GUARDADO); } catch (err) {}
    if (!raw) return;
    try {
      var d = JSON.parse(raw);
      Object.keys(d.st || {}).forEach(function (k) { self.st[k] = d.st[k]; });
      Object.keys(d.imgs || {}).forEach(function (id) {
        var g = d.imgs[id], img = new Image();
        img.onload = function () { self.render(); self.programaMiniaturas(); };
        img.src = g.src;
        self.imgs[id] = { img: img, src: g.src, nombre: g.nombre, w: g.w, h: g.h, tipo: g.tipo };
      });
      if (this.st.logo && !this.imgs[this.st.logo]) this.st.logo = null;
      if (!CR80[this.st.orient]) this.st.orient = 'h';
      this.st.sel = null;
      this._ultima = this.instantanea();
      if (this.st.empezado) this.ocultaInicio();
    } catch (err) {}
  };
  Editor.prototype.leerUrl = function () {
    var q = new URLSearchParams(window.location.search), st = this.st, cfg = this.cfg;
    var hay = false;
    if (q.get('empresa')) { st.empresa = q.get('empresa').slice(0, 60); hay = true; }
    if (q.get('color') && hexValido(q.get('color'))) { st.c1 = q.get('color').toUpperCase(); hay = true; }
    if (q.get('acento') && hexValido(q.get('acento'))) { st.c2 = q.get('acento').toUpperCase(); hay = true; }
    if (q.get('orientacion') === 'v' || q.get('orientacion') === 'h') { st.orient = q.get('orientacion'); hay = true; }
    if (q.get('uso')) {
      var buscado = q.get('uso').toLowerCase();
      cfg.usos.forEach(function (u, i) {
        if (u.etiqueta.toLowerCase() === buscado || (u.clave && u.clave === buscado)) { st.uso = i; if (u.chip) st.chip = u.chip; hay = true; }
      });
    }
    if (q.get('material') === 'metal' || q.get('material') === 'color') { st.material = q.get('material'); }
    if (q.get('metal') === 'oro' || q.get('metal') === 'plata') { st.material = 'metal'; st.metal = q.get('metal'); }
    if (cfg.materialInicial && !q.get('material')) st.material = cfg.materialInicial;
    var pl = q.get('plantilla');
    if (hay || pl) {
      var u = cfg.usos[st.uso] || {};
      var id = pl && PARES[pl] ? pl : (st.orient === 'v' ? (u.plantillaV || 'v-acreditacion') : (u.plantillaH || 'h-corporativa'));
      if (id.charAt(0) !== st.orient) id = PARES[id];
      st.c2 = st.c2 || '#0A0A0A';
      this.aplicaPlantillaInicial = id;
    }
  };

  Editor.prototype.arrancar = function () {
    if (this.aplicaPlantillaInicial) {
      var id = this.aplicaPlantillaInicial;
      this.aplicaPlantillaInicial = null;
      this.aplicaPlantilla(id, true);
      this._ultima = this.instantanea();
    }
  };

  /* ------------------------------------------------------------------
     Iconos (trazos propios, 20 x 20)
  ------------------------------------------------------------------ */
  var ICONOS = {
    texto: '<path d="M4 5h12M10 5v11M7.5 16h5"/>',
    variable: '<circle cx="10" cy="7" r="3"/><path d="M4.5 16.5c.9-2.8 3-4.3 5.5-4.3s4.6 1.5 5.5 4.3"/>',
    imagen: '<rect x="3" y="4" width="14" height="12" rx="1.5"/><circle cx="7.5" cy="8.5" r="1.5"/><path d="m4 15 4.5-4.5 3 3L14 11l3 3"/>',
    qr: '<rect x="3.5" y="3.5" width="5" height="5"/><rect x="11.5" y="3.5" width="5" height="5"/><rect x="3.5" y="11.5" width="5" height="5"/><path d="M11.5 11.5h2v2h-2zM15 15h1.5v1.5H15zM13.5 13.5H15V15h-1.5z"/>',
    foto: '<rect x="4" y="3" width="12" height="14" rx="1.5"/><circle cx="10" cy="8.5" r="2.4"/><path d="M6.3 15c.6-1.9 2-3 3.7-3s3.1 1.1 3.7 3"/>',
    nfc: '<circle cx="6" cy="10" r=".9"/><path d="M8.6 7.4a3.7 3.7 0 0 1 0 5.2M11 5a7 7 0 0 1 0 10M13.4 2.8a10 10 0 0 1 0 14.4"/>',
    rect: '<rect x="3.5" y="5" width="13" height="10" rx="1"/>',
    elipse: '<circle cx="10" cy="10" r="6.5"/>',
    linea: '<path d="M3.5 10h13"/>',
    subir: '<path d="M10 13V4M6.5 7.5 10 4l3.5 3.5M4 13.5V16h12v-2.5"/>',
    papelera: '<path d="M4.5 6h11M8 6V4.5h4V6M6 6l.7 10h6.6L14 6"/>',
    'al-izq': '<path d="M4 5h12M4 8.5h8M4 12h12M4 15.5h8"/>',
    'al-cen': '<path d="M4 5h12M6 8.5h8M4 12h12M6 15.5h8"/>',
    'al-der': '<path d="M4 5h12M8 8.5h8M4 12h12M8 15.5h8"/>'
  };
  function icono(n) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 20 20'); s.setAttribute('aria-hidden', 'true'); s.setAttribute('class', 'ne-i');
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '1.5');
    s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
    s.innerHTML = ICONOS[n] || ICONOS.rect;
    return s;
  }

  /* ------------------------------------------------------------------
     Arranque
  ------------------------------------------------------------------ */
  function iniciar() {
    $$('[data-nfcard-editor]').forEach(function (raiz) {
      if (raiz.__editor) return;
      var cfgEl = $('script[type="application/json"]', raiz);
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return; }
      var ed = new Editor(raiz, cfg);
      ed.arrancar();
      raiz.__editor = ed;
      window.nfcardEditor = ed;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
